<template>
  <div>
    <div v-if="userDataLoaded == true" class="content-header-minimum barometers clear">
      <div class="clear">
        <v-container grid-list-md class="pa-0" fluid>
          <v-layout row wrap>
            <v-flex md3 xs12 v-if="dataloaded && companies.length > 1 && !demoMode">
              <v-select
                class="my-2"
                :items="filteredCompanies"
                :item-color="companyPrimaryColor"
                background-color="menu"
                item-text="name"
                item-value="id"
                v-on:input="loadBranches()"
                v-model="activeComp"
                no-data-text="Geen bedrijven gevonden."
                label="Selecteer bedrijf"
                outlined
                hide-details
                dense>
                <template v-slot:prepend-item>
                  <v-list-item>
                    <v-list-item-content  class="pt-0" >
                      <v-text-field
                        :color="companyPrimaryColor"
                        placeholder="Zoeken"
                        prepend-inner-icon="search"
                        v-model="searchCompanies"
                        clearable
                        hide-details
                        dense
                      ></v-text-field>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <div v-if="searchCompanies && searchCompanies.length > 0" style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px">{{ filteredCompanies.length }} van {{ companies.length }} bedrijven</div>
                  <v-divider v-if="searchCompanies && searchCompanies.length > 0"></v-divider>
                </template>
              </v-select>
            </v-flex>
            <v-flex :class="filterGridClass" xs12 v-if="dataloaded">
              <v-select
                outlined
                class="my-2"
                :color="companyPrimaryColor"
                :item-color="companyPrimaryColor"
                :items="branches"
                item-text="branchName"
                item-value="id"
                v-model="selectedBranches"
                multiple
                label="Vestigingen"
                attach
                hide-details
                chips
                dense
                background-color="menu"
                >
                <template v-slot:selection="{ item, index }">
                  <v-chip small v-if="index === 0">{{ item.branchName }}</v-chip>
                  <v-chip small v-if="index === 1">{{ item.branchName }}</v-chip>
                  <v-chip small v-if="index === 2">{{ item.branchName }}</v-chip>
                  <span style="color: #666; font-size: 14px;"
                    v-if="index === 3"
                  > + {{ selectedBranches.length - 3}} anderen 
                  </span>
                </template>
              </v-select>
            </v-flex>
            <v-flex v-if="dataloaded && branches.length > 1" md3 xs12>
              <v-btn
                class="my-2"
                block
                height="40px"
                :darken="branchesChanged"
                :depressed="!branchesChanged"
                :disabled="!branchesChanged"
                :color="companyPrimaryColor"
                @click="loadSelectedBranchesData()"
                >
                <span style="color: #fff;">Barometers laden</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </div>

    <div v-if="!dataloaded || !userDataLoaded" class="blackbox-loader"></div>

    <v-card outlined v-if="(userRole == 'admin' && dataloaded && !loadingError && !noData) || (userRole == 'superadmin' && dataloaded && !loadingError && !noData)">
      <v-container grid-list-md fluid class="ma-0 pa-1">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex md3 xs12>
            <v-select
              :color="companyPrimaryColor"
              :item-color="companyPrimaryColor"
              :items="dataView"
              item-text="name"
              item-value="id"
              outlined
              dense
              background-color="background"
              v-model="dataFilter.selectedDataView"
              label="Selecteer dataweergave"
              hide-details
              v-on:input="setSelectedDates()"
            ></v-select>
          </v-flex>
          <v-flex md3 xs12>
            <v-select
              :color="companyPrimaryColor"
              :item-color="companyPrimaryColor"
              :items="dataYear"
              outlined
              dense
              background-color="background"
              v-model="dataFilter.selectedDataYear"
              label="Selecteer jaar"
              v-on:input="checkAvailableDates()"
              hide-details
            ></v-select>
          </v-flex>
          <v-flex md3 xs12 v-if="dataFilter.selectedDataView == 'months'">
            <v-select
              :color="companyPrimaryColor"
              :item-color="companyPrimaryColor"
              :items="months"
              outlined
              dense
              background-color="background"
              item-text="name"
              item-value="id"
              v-model="dataFilter.selectedDataMonths"
              label="Selecteer maand"
              hide-details
              v-on:input="setSelectedDates()"
            ></v-select>
          </v-flex>
          <v-flex md3 xs12 v-if="dataFilter.selectedDataView == 'fourweeks'">
            <v-select
              :color="companyPrimaryColor"
              :item-color="companyPrimaryColor"
              :items="fourWeeks"
              outlined
              dense
              background-color="background"
              item-text="name"
              item-value="id"
              item-disabled="disabled"
              v-model="dataFilter.selectedDataFourWeeks"
              label="Selecteer periode"
              hide-details
              v-on:input="setSelectedDates()"
            ></v-select>
          </v-flex>
          <v-flex md3 xs12 v-if="dataFilter.selectedDataView == 'weeks'">
            <v-select
              :color="companyPrimaryColor"
              :items="weeks"
              outlined
              dense
              background-color="background"
              item-text="name"
              item-value="id"
              item-disabled="disabled"
              v-model="dataFilter.selectedDataWeek"
              label="Selecteer weeknummer"
              hide-details
              v-on:input="setSelectedDates()"
            ></v-select>
          </v-flex>
          <v-flex md3 xs12>
            <v-btn
              block
              large
              height="40px"
              :depressed="branchesChanged"
              :disabled="filterChanged"
              :color="companyPrimaryColor"
              @click="dataloaded = false, updateFilter()"
            >
              <span style="color: #fff;">Filteren</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>

    <div class="text-right" v-if="dataloaded && !loadingError">
      <v-btn class="ma-2" color="#fff" rounded @click="loadSelectedBranchesData()">
        <v-icon dark color="#333">refresh</v-icon>&nbsp;
        <span style="color: #333">Refresh</span>
      </v-btn>

      <v-btn class="ma-2" icon v-if="userRole == 'admin' || userRole == 'superadmin'" @click="barometerSettingCompanyDialog = true">
        <v-icon>settings</v-icon>
      </v-btn>
    </div>

    <div class="no-salon-data" v-if="dataloaded == true && noData == true && !loadingError">
      <p>Selecteer salons en klik op <strong>Barometers laden</strong> om data te laden.
      </p>
    </div>
    <div class="no-salon-data" v-if="dataloaded == true && noData == false && loadingError">
      <v-layout justify-space-around>
        <v-icon large color="warning">warning</v-icon>
      </v-layout>
      <p style="padding: 10px">{{loadingError}}</p>
    </div>

    <div v-if="dataloaded && !noData && !loadingError">
      <div class="branch-barometer-wrapper" v-for="branch in selectedBranchesData" :key="branch.id">
        <div class="branch-barometer-header">
          <h2>Salon {{ branch.branchName}}</h2>
          <div class="edit-icon">
            <v-btn
              v-if="userRole == 'admin' || userRole == 'superadmin'"
              fab
              dark
              small
              :color="companyPrimaryColor"
              @click="barometerSettingBranch(branch)"
              >
              <v-icon dark>settings</v-icon>
            </v-btn>
          </div>
        </div>

        <template>
          <v-container grid-list-md class="barometer-container">
            <v-layout row wrap>
              <v-flex lg3 md4 d-flex v-if="activeCompDataOriginal.barometersSettings.showMonthBarometer">
                <gauge4weekstotal
                  :canvasID="branch.id+'total4weeks'"
                  :selectedDataView="dataFilterSaved.selectedDataView"
                  :selectedDataWeek="dataFilterSaved.selectedDataWeek"
                  :selectedDataMonths="dataFilterSaved.selectedDataMonths"
                  :selectedDataFourWeeks="dataFilterSaved.selectedDataFourWeeks"
                  :months="months"
                  :weeknr="weektime"
                  :rate="totalPeriodData.percentageActual[branch.branchNameSalonhub]"
                  :target="totalPeriodData.percentageSaleTarget[branch.branchNameSalonhub]"
                  level="90"
                  marks="1,2,3"
                  aperture="240"
                  :compDataView="activeCompDataOriginal.barometersSettings.dataView"
                  :colorStop="companySecondaryColorRGBA"
                  :colorStart="companySecondaryColorRGBA"
                  :colorPrimary="companyPrimaryColorRGBA"
                  :useManualGoals="branch.barometersSettings.useManualGoals"
                ></gauge4weekstotal>
              </v-flex>
              <v-flex lg3 md4 d-flex v-if="activeCompDataOriginal.barometersSettings.showWeekGoalBarometer">
                <gaugeTotal
                  :canvasID="branch.id+'total'"
                  :selectedDataView="dataFilterSaved.selectedDataView"
                  :selectedDataWeek="dataFilterSaved.selectedDataWeek"
                  :selectedDataMonths="dataFilterSaved.selectedDataMonths"
                  :selectedDataFourWeeks="dataFilterSaved.selectedDataFourWeeks"
                  :months="months"
                  :weeknr="weektime"
                  :rate="totalData.percentageActual[branch.branchNameSalonhub]"
                  level="90"
                  marks="1,2,3"
                  aperture="240"
                  :colorStop="companySecondaryColor"
                  :colorStart="companySecondaryColor"
                  :useManualGoals="branch.barometersSettings.useManualGoals"
                ></gaugeTotal>
              </v-flex>

              <v-flex lg3 md4 d-flex v-if="activeCompDataOriginal.barometersSettings.showWeekGoalTreatmentsBarometer">
                <gaugeTreatment
                  :canvasID="branch.id+'treatment'"
                  :selectedDataView="dataFilterSaved.selectedDataView"
                  :selectedDataWeek="dataFilterSaved.selectedDataWeek"
                  :selectedDataMonths="dataFilterSaved.selectedDataMonths"
                  :selectedDataFourWeeks="dataFilterSaved.selectedDataFourWeeks"
                  :months="months"
                  :weeknr="weektime"
                  :rate="treatmentData.percentageActual[branch.branchNameSalonhub]"
                  :target="treatmentData.percentageManipulate[branch.branchNameSalonhub]"
                  level="90"
                  marks="1,2,3"
                  aperture="240"
                  :colorStop="companySecondaryColor"
                  :colorStart="companySecondaryColor"
                  :useManualGoals="branch.barometersSettings.useManualGoals"
                ></gaugeTreatment>
              </v-flex>

              <v-flex lg3 md4 d-flex v-if="activeCompDataOriginal.barometersSettings.showWeekGoalProductsBarometer && !activeCompDataOriginal.barometersSettings.useRevenuePercentageForProducts">
                <gaugeProduct
                  :canvasID="branch.id+'product'"
                  :selectedDataView="dataFilterSaved.selectedDataView"
                  :selectedDataWeek="dataFilterSaved.selectedDataWeek"
                  :selectedDataMonths="dataFilterSaved.selectedDataMonths"
                  :selectedDataFourWeeks="dataFilterSaved.selectedDataFourWeeks"
                  :months="months"
                  :weeknr="weektime"
                  :rate="productData.percentageActual[branch.branchNameSalonhub]"
                  :target="productData.percentageManipulate[branch.branchNameSalonhub]"
                  level="90"
                  marks="1,2,3"
                  aperture="240"
                  :colorStop="companySecondaryColor"
                  :colorStart="companySecondaryColor"
                  :useManualGoals="branch.barometersSettings.useManualGoals"
                ></gaugeProduct>
              </v-flex>

              <v-flex lg3 md4 d-flex v-if="activeCompDataOriginal.barometersSettings.showWeekGoalProductsBarometer && activeCompDataOriginal.barometersSettings.useRevenuePercentageForProducts">
                <gaugeProductRevenue
                  :canvasID="branch.id+'product'"
                  :selectedDataView="dataFilterSaved.selectedDataView"
                  :selectedDataWeek="dataFilterSaved.selectedDataWeek"
                  :selectedDataMonths="dataFilterSaved.selectedDataMonths"
                  :selectedDataFourWeeks="dataFilterSaved.selectedDataFourWeeks"
                  :months="months"
                  :weeknr="weektime"
                  :revenue="totalData.actual[branch.branchNameSalonhub]"
                  :revenueProducts="productData.actual[branch.branchNameSalonhub]"
                  :rate="(productData.actual[branch.branchNameSalonhub] / totalData.actual[branch.branchNameSalonhub]) * 100"
                  :target="(totalData.actual[branch.branchNameSalonhub] / 100) * branch.barometersSettings.ProductSaleRevenueTarget"
                  :targetPercentage="branch.barometersSettings.ProductSaleRevenueTarget"
                  level="90"
                  marks="1,2,3"
                  aperture="240"
                  :colorStop="companySecondaryColor"
                  :colorStart="companySecondaryColor"
                  :useManualGoals="branch.barometersSettings.useManualGoals"
                ></gaugeProductRevenue>
              </v-flex>

              <v-flex lg3 md4 d-flex v-if="activeCompDataOriginal.barometersSettings.showCustomProductData">
                <gaugeCustomProductData
                  :selectedDataView="dataFilterSaved.selectedDataView"
                  :selectedDataWeek="dataFilterSaved.selectedDataWeek"
                  :selectedDataMonths="dataFilterSaved.selectedDataMonths"
                  :selectedDataFourWeeks="dataFilterSaved.selectedDataFourWeeks"
                  :selectedDataYear="dataFilterSaved.selectedDataYear"
                  :months="months"
                  :canvasID="customProductData + 'CustomProduc' + branch.branchNameSalonhub"
                  :weeknr="weektime"
                  level="90"
                  marks="1,2,3"
                  aperture="240"
                  :rate="customProductData[branch.branchNameSalonhub]"
                  :colorStop="companySecondaryColor"
                  :colorStart="companySecondaryColor"
                  :useManualGoals="branch.barometersSettings.useManualGoals"
                ></gaugeCustomProductData>
              </v-flex>

              <v-flex lg3 md4 d-flex v-if="activeCompDataOriginal.barometersSettings.showWeekGoalColorsBarometer">
                <gaugeColour
                  :canvasID="branch.id+'Colour'"
                  :selectedDataView="dataFilterSaved.selectedDataView"
                  :selectedDataWeek="dataFilterSaved.selectedDataWeek"
                  :selectedDataMonths="dataFilterSaved.selectedDataMonths"
                  :selectedDataFourWeeks="dataFilterSaved.selectedDataFourWeeks"
                  :months="months"
                  :weeknr="weektime"
                  :rate="colourData.actual[branch.branchNameSalonhub]"
                  :target="colourData.colourTarget[branch.branchNameSalonhub]"
                  level="90"
                  marks="1,2,3"
                  aperture="240"
                  :colorStop="companySecondaryColor"
                  :colorStart="companySecondaryColor"
                  :useManualGoals="branch.barometersSettings.useManualGoals"
                ></gaugeColour>
              </v-flex>
              <v-flex lg3 md4 d-flex v-if="activeCompDataOriginal.barometersSettings.showRevenuePerTicketBarometer">
                <gaugeRevenueTicket
                  :canvasID="branch.id+'RevenuePerTicket'"
                  :selectedDataMonths="dataFilterSaved.selectedDataMonths"
                  :months="months"
                  :rate="revenuePerTicket[branch.branchNameSalonhub].current"
                  :target="revenuePerTicket[branch.branchNameSalonhub].target"
                  level="90"
                  marks="1,2,3"
                  aperture="240"
                  :colorStop="companySecondaryColor"
                  :colorStart="companySecondaryColor"
                  :useManualGoals="branch.barometersSettings.useManualGoals"
                ></gaugeRevenueTicket>
              </v-flex>

              <v-flex lg3 md4 d-flex v-if="creativeData.show[branch.branchNameSalonhub] && activeCompDataOriginal.barometersSettings.showCreativeBarometer">
                <gaugeCreative
                  :canvasID="branch.id+'Creative'"
                  :day="day"
                  :rate="creativeData.percentageActual[branch.branchNameSalonhub]"
                  :target="creativeData.target[branch.branchNameSalonhub]"
                  level="90"
                  marks="1,2,3"
                  aperture="240"
                  :colorStop="companySecondaryColor"
                  :colorStart="companySecondaryColor"
                  :useManualGoals="branch.barometersSettings.useManualGoals"
                ></gaugeCreative>
              </v-flex>

              <v-flex lg3 md4 d-flex v-if="activeCompDataOriginal.barometersSettings.showAppointments && AppointmentsThisYear[branch.branchNameSalonhub][0] && AppointmentsYearAgo[branch.branchNameSalonhub][0]">
                <visitors
                  :selectedDataView="dataFilterSaved.selectedDataView"
                  :selectedDataWeek="dataFilterSaved.selectedDataWeek"
                  :selectedDataMonths="dataFilterSaved.selectedDataMonths"
                  :selectedDataFourWeeks="dataFilterSaved.selectedDataFourWeeks"
                  :months="months"
                  :weeknr="weektime"
                  :appointmentsThisYear="AppointmentsThisYear[branch.branchNameSalonhub][0].data"
                  :appointmentsYearAgo="AppointmentsYearAgo[branch.branchNameSalonhub][0].data"
                  :colorSecondary="companySecondaryColor"
                  :colorPrimary="companyPrimaryColor"
                  :useManualGoals="branch.barometersSettings.useManualGoals"
                ></visitors>
              </v-flex>
            </v-layout>

            <v-expansion-panels :value="0" style="margin: 20px 0;" v-if="(employeeloaded && dataloaded && activeCompDataOriginal.barometersSettings.showEmployeeBarometer && !activeCompDataOriginal.barometersSettings.showEmployeeBarometerOnlyToManager) || (employeeloaded == true && dataloaded == true && activeCompDataOriginal.barometersSettings.showEmployeeBarometer && userRole != 'employee')">
              <v-expansion-panel>
                <v-expansion-panel-header><h3>Medewerkers Salon {{ branch.branchName}}</h3></v-expansion-panel-header>
                <v-expansion-panel-content >
                  <v-container grid-list-md style="max-width: 100%">
                    <v-layout row wrap>
                      <v-flex
                        md6
                        d-flex
                        class="employee-barometer-wrapper"
                        v-for="(employeeBench, index) in reportEmployee[branch.branchNameSalonhub][0].data.employees"
                        :key="employeeBench.name + employeeBench.id + index"
                        v-if="!activeCompData.benchmarkEmployees[employeeBench.id] || (activeCompData.benchmarkEmployees[employeeBench.id] && !activeCompData.benchmarkEmployees[employeeBench.id].hide)">
                        <v-card outlined flat style="width: 100%">
                          <div class="barometer-wrapper">
                            <div class="barometer-header">
                              <h2>{{ employeeBench.name }} ({{ branch.branchName}})</h2>
                              <!-- <h2>Product ID: {{employeeName}} {{employeeID}}</h2> -->
                              <div >
                              <h3 v-if="dataFilterSaved.selectedDataView == 'months'">
                                <span v-for="(month, index) in months" :key="index">
                                  <span
                                    v-if="month.id == dataFilterSaved.selectedDataMonths"
                                  >{{ month.name }}</span>
                                </span>
                              </h3>
                              <h3
                                v-if="dataFilterSaved.selectedDataView == 'fourweeks'"
                              >week {{(dataFilterSaved.selectedDataFourWeeks * 4) - 3 }} t/m {{(dataFilterSaved.selectedDataFourWeeks * 4)}}</h3>
                              <h3
                                v-if="dataFilterSaved.selectedDataView == 'weeks'"
                              >week {{ dataFilterSaved.selectedDataWeek }}</h3>
                              </div>
                            </div>
                            <v-btn
                              style="position: absolute; top: 10px; right: 10px;"
                              icon
                              small
                              v-if="userRole == 'manager' || userRole == 'admin' || userRole == 'superadmin'"
                              @click="employeeBarometerSetting(employeeBench)"
                              >
                              <v-icon medium dark color="#555555">settings</v-icon>
                            </v-btn>
                            <!-- v-if="activeCompData.benchmarkEmployees[employeeBench.name]" -->
                            <v-layout row wrap>
                              <v-flex xs6 d-flex v-if="activeCompDataOriginal.barometersSettings.showRevenuePerHourEmployee">
                                <employeeBenchmark
                                  :canvasID="employeeBench.name + ' ' + branch.branchName"
                                  :employeeTarget="activeCompData.benchmarkEmployees[employeeBench.id]"
                                  :employeeName="employeeBench.name"
                                  :weeknr="weektime"
                                  :rate="employeeBench.revenuePerHour"
                                  :hourRateAmmount="activeCompData.barometersSettings.showHourrateAmmount"
                                  level="90"
                                  marks="1,2,3"
                                  aperture="240"
                                  :colorStop="companySecondaryColor"
                                  :colorStart="companySecondaryColor"
                                ></employeeBenchmark>
                              </v-flex>

                              <v-flex xs6 d-flex v-if="activeCompDataOriginal.barometersSettings.dyflexis && activeCompDataOriginal.barometersSettings.showRevenuePerHourEmployeeDyflexis">
                                <employeeBenchmarkDyflexis
                                  :canvasID="employeeBench.name + ' ' + branch.branchName + 'prod'"
                                  :employeeTarget="activeCompData.benchmarkEmployees[employeeBench.id]"
                                  :employeeName="employeeBench.name"
                                  :weeknr="weektime"
                                  :rate="employeeBench.productive"
                                  level="90"
                                  :revenue="employeeBench.revenue"
                                  :dyflexis="employeeBench.dyflexis"
                                  :dyflexisHours="employeeBench.dyflexisHours"
                                  :dyflexisType="employeesWorkedHours[branch.id].type"
                                  marks="1,2,3"
                                  aperture="240"
                                  :colorStop="companySecondaryColor"
                                  :colorStart="companySecondaryColor"
                                ></employeeBenchmarkDyflexis>
                              </v-flex>

                              <v-flex xs6 d-flex v-if="activeCompDataOriginal.barometersSettings.showProductivityEmployee">
                                <employeeProductivity
                                  :canvasID="employeeBench.name + ' ' + branch.branchName + 'prod'"
                                  :employeeTarget="activeCompData.benchmarkEmployees[employeeBench.id]"
                                  :employeeName="employeeBench.name"
                                  :weeknr="weektime"
                                  :rate="employeeBench.productive"
                                  level="90"
                                  marks="1,2,3"
                                  aperture="240"
                                  :colorStop="companySecondaryColor"
                                  :colorStart="companySecondaryColor"
                                ></employeeProductivity>
                              </v-flex>

                              <v-flex xs6 d-flex v-if="activeCompDataOriginal.barometersSettings.showProductEmployee">
                                <div v-for="(productEmployee, index) in financeEmployee" :key="index+'productpercentage'">
                                  <div v-if="employeeBench.id == productEmployee.id && [branch.branchNameSalonhub] == productEmployee.branch">
                                    <gaugeProductEmployee
                                      :selectedDataView="dataFilterSaved.selectedDataView"
                                      :selectedDataWeek="dataFilterSaved.selectedDataWeek"
                                      :selectedDataMonths="dataFilterSaved.selectedDataMonths"
                                      :selectedDataFourWeeks="dataFilterSaved.selectedDataFourWeeks"
                                      :months="months"
                                      :canvasID="productEmployee.name + 'product' + branch.branchName"
                                      :employeeTarget="activeCompData.benchmarkEmployees[employeeBench.id]"
                                      :employeeID="productEmployee.id"
                                      :employeeName="productEmployee.name"
                                      :weeknr="weektime"
                                      level="90"
                                      marks="1,2,3"
                                      aperture="240"
                                      :rate="productEmployee.products"
                                      :colorStop="companySecondaryColor"
                                      :colorStart="companySecondaryColor"
                                    ></gaugeProductEmployee>
                                  </div>
                                </div>
                              </v-flex>

                              <v-flex xs6 d-flex v-if="activeCompDataOriginal.barometersSettings.showFourWeekBarometer">
                                <div v-for="(TotalRevenueEmployee, index) in financeEmployee"  :key="index+'4weeksrevenue'">
                                  <div v-if="employeeBench.id == TotalRevenueEmployee.id && [branch.branchNameSalonhub] == TotalRevenueEmployee.branch">
                                    <gauge4weeksRevenueEmployee
                                      :selectedDataView="dataFilterSaved.selectedDataView"
                                      :selectedDataWeek="dataFilterSaved.selectedDataWeek"
                                      :selectedDataMonths="dataFilterSaved.selectedDataMonths"
                                      :selectedDataFourWeeks="dataFilterSaved.selectedDataFourWeeks"
                                      :selectedDataYear="dataFilterSaved.selectedDataYear"
                                      :months="months"
                                      :canvasID="TotalRevenueEmployee.name + 'fourweeks' + branch.branchName"
                                      :employeeTarget="activeCompData.benchmarkEmployees[employeeBench.id]"
                                      :employeeID="TotalRevenueEmployee.id"
                                      :employeeName="TotalRevenueEmployee.name"
                                      :weeknr="weektime"
                                      level="90"
                                      marks="1,2,3"
                                      aperture="240"
                                      :rate="TotalRevenueEmployee.fourweeksTotalRevenue"
                                      :colorStop="companySecondaryColorRGBA"
                                      :colorStart="companySecondaryColorRGBA"
                                      :colorPrimary="companyPrimaryColorRGBA"
                                    ></gauge4weeksRevenueEmployee>
                                  </div>
                                </div>
                              </v-flex>

                              <v-flex xs6 d-flex v-if="activeCompDataOriginal.barometersSettings.showSoldProducts">
                                <div v-for="(productSold, index) in productEmployee" :key="index+productSold.id">
                                  <gaugeProductSold
                                    v-if="employeeBench.id == productSold.id && [branch.branchNameSalonhub] == productSold.branch "
                                    :selectedDataView="dataFilterSaved.selectedDataView"
                                    :selectedDataWeek="dataFilterSaved.selectedDataWeek"
                                    :selectedDataMonths="dataFilterSaved.selectedDataMonths"
                                    :selectedDataFourWeeks="dataFilterSaved.selectedDataFourWeeks"
                                    :selectedDataYear="dataFilterSaved.selectedDataYear"
                                    :months="months"
                                    :canvasID="productSold.name + 'productSold' + branch.branchName"
                                    :employeeTarget="activeCompData.benchmarkEmployees[employeeBench.id]"
                                    :employeeID="productSold.id"
                                    :employeeName="productSold.name"
                                    :weeknr="weektime"
                                    level="90"
                                    marks="1,2,3"
                                    aperture="240"
                                    :rate="productSold.productcount"
                                    :colorStop="companySecondaryColor"
                                    :colorStart="companySecondaryColor"
                                  ></gaugeProductSold>
                                </div>
                              </v-flex>
                              <v-flex xs6 d-flex v-if="activeCompData.benchmarkEmployees[employeeBench.id] && activeCompData.barometersSettings.showAllround">
                                <employeeAllround
                                  v-if="activeCompData.benchmarkEmployees[employeeBench.id].allround"
                                  :canvasID="employeeBench.name + ' ' + branch.branchName + 'allround'"
                                  :employeeTarget="activeCompData.benchmarkEmployees[employeeBench.id]"
                                  :employeeName="employeeBench.name"
                                  :employeeID="employeeBench.id"
                                  :allRoundEmployees="allRoundEmployees"
                                  :selectedBranch="selectedBranchesSalonhub"
                                  :hourRateAmmount="activeCompData.barometersSettings.showHourrateAmmount"
                                  :weeknr="weektime"
                                  level="90"
                                  marks="1,2,3"
                                  aperture="240"
                                  :colorStop="companySecondaryColor"
                                  :colorStart="companySecondaryColor"
                                ></employeeAllround>
                              </v-flex>
                            </v-layout>
                          </div>
                        </v-card>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex
                        md6
                        class="employee-barometer-wrapper"
                        v-for="(employeeBench, index) in reportEmployee[branch.branchNameSalonhub][0].data.employees"
                        :key="employeeBench.name + employeeBench.id + index"
                        v-if="activeCompData.benchmarkEmployees[employeeBench.id] && activeCompData.benchmarkEmployees[employeeBench.id].hide"
                        >
                        <v-card outlined flat style="width: 100%">
                          <div class="barometer-wrapper">
                            <div class="barometer-header pa-0">
                              <h2>{{ employeeBench.name }} ({{ branch.branchName}})</h2>
                            </div>
                              
                            <v-btn
                              style="position: absolute; top: 10px; right: 10px;"
                              icon
                              small
                              v-if="userRole == 'manager' || userRole == 'admin' || userRole == 'superadmin'"
                              @click="employeeBarometerSetting(employeeBench)"
                              >
                              <v-icon medium dark color="#555555">settings</v-icon>
                            </v-btn>
                          </div>
                        </v-card>

                      </v-flex>
                      <!-- <v-flex
                        lg3
                        md4
                        d-flex
                        class="employee-barometer-wrapper"
                        v-for="employeeProducts in financeEmployee[branch.branchNameSalonhub][this].data.employees"
                        :key="employeeBench.name+'id'"
                      >
                      </v-flex>-->
                    </v-layout>
                  </v-container>

                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

      
          </v-container>
        </template>
      </div>
    </div>

    <!-- Later bruikbaar voor medewerkers Resources -->
    <!-- <v-flex xs3 v-for="products in productData" :key="products.id">
            <gaugeProduct ref="" :canvasID="products.id" :rate="products.value" :target="products.target" level="90" marks="1,2,3" aperture="240" colors="80:#f8f3bc,100:#eee"></gaugeProduct>
    </v-flex>-->
    <!--
    <v-container fluid >
      <v-layout  justify-start row  >
        <v-flex xs4 offset-xs1>
          <div v-for="products in productData" :key="products.id">
            <gaugeProduct ref="" :canvasID="products.id" :rate="products.value" :target="products.target" level="90" marks="1,2,3" aperture="240" colors="80:#f8f3bc,100:#eee"></gaugeProduct>
          </div>
        </v-flex>
      </v-layout>
    </v-container>-->

    <!-- / Edit Barometer Company Settings Dialog \ -->
    <v-dialog
      v-model="barometerSettingCompanyDialog"
      scrollable
      max-width="900px"
      v-if="dataloaded == true"
    >
      <edit-barometer-company-settings-form
        :activeCompData="activeCompData"
        :activeCompDataOriginal="activeCompDataOriginal"
        @editBarometerCompanySettingsDialogChange="barometerSettingCompanyDialog = $event"
        @updateData="loadSelectedBranchesData()"
      ></edit-barometer-company-settings-form>
    </v-dialog>
    <!-- \  Edit Barometer Company Settings Dialog / -->
    <!-- / Edit Barometer Branch Settings Dialog \ -->
    <v-dialog v-model="barometerSettings" scrollable max-width="900px" v-if="dataloaded == true">
      <edit-barometer-settings-form
        :activeCompData="activeCompData"
        :activeBranchOriginal="selectedBranchOriginal"
        :activeBranch="selectedBranch"
        @editBarometerSettingsDialogChange="barometerSettings = $event"
        @updateData="loadSelectedBranchesData()"
      ></edit-barometer-settings-form>
    </v-dialog>
    <!-- \  Edit Barometer Branch Settings Dialog / -->
    <!-- / Edit Barometer Employee Dialog \ -->
    <v-dialog v-model="employeeSettings" scrollable max-width="900px" v-if="dataloaded == true">
      <edit-barometer-employee-form
        :selectedEmployeeGoal="selectedEmployeeGoal"
        :selectedEmployeeGoalOriginal="selectedEmployeeGoalOriginal"
        :activeCompData="activeCompData"
        :activeEmployee="selectedEmployee"
        @editBarometerEmployeeDialogChange="employeeSettings = $event"
        @updateData="loadSelectedBranchesData()"
      ></edit-barometer-employee-form>
    </v-dialog>
    <!-- \  Edit Barometer Employee Dialog / -->
  </div>
</template>
<style >
.barometer-container {
  padding: 0 0 20px 0;
  max-width: 100%;
}

.branch-barometer-header {
  position: relative;
  padding: 10px 0;
  margin: 0 0 20px 0;
  border-bottom: 1px solid #e8e9ee;
}

.branch-barometer-header .edit-icon {
  position: absolute;
  right: 0;
  top: 0;
}
.v-list--disabled .v-list__tile__title {
  color: #ccc !important;
}
</style>

<script>
import firebase from "firebase/app";
import db from "../firebase/init";
import { bus } from "../main";
import gaugeProduct from "../components/elements/gaugeProduct";
import gaugeProductRevenue from "../components/elements/gaugeProductRevenue";
import gaugeProductSold from "../components/elements/gaugeProductSold";
import gaugeProductEmployee from "../components/elements/gaugeProductEmployee";
import gauge4weeksRevenueEmployee from "../components/elements/gauge4weeksRevenueEmployee";
import gaugeCustomProductData from "../components/elements/gaugeCustomProductData";
import gaugeTreatment from "../components/elements/gaugeTreatment";
import gaugeTotal from "../components/elements/gaugeTotal";
import gauge4weekstotal from "../components/elements/gauge4weekstotal";
import gaugeColour from "../components/elements/gaugeColour";
import gaugeRevenueTicket from "../components/elements/gaugeRevenueTicket";
import gaugeCreative from "../components/elements/gaugeCreative";
import employeeBenchmark from "../components/elements/employeeBenchmark";
import employeeBenchmarkDyflexis from "../components/elements/employeeBenchmarkDyflexis";
import employeeProductivity from "../components/elements/employeeProductivity";
import employeeAllround from "../components/elements/employeeAllround";
import visitors from "../components/elements/Visitors";

import axios from "axios";
import moment from "moment";
import _ from "lodash";
import EditBarometerCompanySettingsForm from "../components/modals/EditBarometerCompanySettingsForm.vue";
import EditBarometerSettingsForm from "../components/modals/EditBarometerSettingsForm.vue";
import EditBarometerEmployeeForm from "../components/modals/EditBarometerEmployeeForm.vue";

export default {
  components: {
    gaugeProduct,
    gaugeProductEmployee,
    gauge4weeksRevenueEmployee,
    gaugeProductSold,
    gaugeTreatment,
    gaugeTotal,
    gauge4weekstotal,
    gaugeColour,
    gaugeRevenueTicket,
    gaugeCreative,
    employeeBenchmark,
    employeeBenchmarkDyflexis,
    employeeProductivity,
    employeeAllround,
    gaugeProductRevenue,
    gaugeCustomProductData,
    visitors,
    "edit-barometer-company-settings-form": EditBarometerCompanySettingsForm,
    "edit-barometer-settings-form": EditBarometerSettingsForm,
    "edit-barometer-employee-form": EditBarometerEmployeeForm
  },

  name: "Barometers",
  data: () => ({
    thisweek: moment().format("w"), // Weeknumber Laatste week
    date: null,
    noData: true,
    searchCompanies: "",
    userDataLoaded: false,
    loadingError: null,
    allRoundEmployees: [],
    barometerSettingCompanyDialog: false,
    updateTimeToGo: 20,
    companies: [],
    branches: [],
    dataloaded: false,
    employeeloaded: false,
    selectedBranchesOriginal: [],
    selectedBranches: [],
    selectedBranchesData: [],
    barometersReady: true,
    activeComp: null,
    activeCompData: {},
    activeCompDataOriginal: {},
    productData: {
      //gaugeProduct
      target: {},
      actual: {},
      percentageActual: {},
      percentageSaleTarget: {},
      percentageManipulate: {}
    },
    financeEmployee: [],
    productEmployee: [],
    financeProducts: [],

    treatmentData: {
      //gaugeTreatment
      target: {},
      actual: {},
      percentageActual: {},
      percentageSaleTarget: {},
      percentageManipulate: {}
    },
    totalData: {
      //gaugeTotal
      percentageActual: {},
      target: {},
      actual: {}
    },
    total4weeksData: {
      //gauge4weekstotal
      target: {},
      actual: {},
      percentageActual: {},
      percentageSaleTarget: {},
      percentageManipulate: {}
    },
    totalPeriodData: {
      //4 weken of 1 Maand totaal
      target: {},
      actual: {},
      percentageActual: {},
      percentageSaleTarget: {},
      percentageManipulate: {}
    },

    colourData: {
      actual: {},
      colourTarget: {}
    },
    creativeData: {
      percentageActual: {},
      target: {},
      show: {}
    },
    reportEmployee: {},
    allEmployees: [],
    reportCreative: {},
    selectedEmployee: {},
    selectedEmployeeOriginal: null,

    selectedBranch: {
      barometersSettings: {
        ProductManipulateActive: false,
        TreatmentManipulateActive: false,
        Total4WeeksSaleManipulateActive: false
      }
    },
    revenuePerTicket: {},
    selectedEmployeeGoalOriginal: {},
    selectedEmployeeGoal: {},
    selectedBranchOriginal: {},
    selectedBranchesSalonhub: [],
    selectedBranchesTarget: [],
    customProductData: {},
    SettingYearData: {}, //Vanuit settings database keuze welk jaar vergelijken
    ThisYearData: {}, //Cijfers omzet dit jaar
    Revenue: {}, //Omzet per groep
    AppointmentsYearAgo: {}, //Afpsraken vorig jaar
    AppointmentsThisYear: {}, //Afpsraken dit jaar
    currentYear: moment().year(),
    currentMonth: moment().month(),
    currentWeek: moment().week(),
    momentCurrentYearDate: moment().format("YYYY-MM-DD"),
    yearOneYearsAgo: moment()
      .subtract(1, "years")
      .year(),
    yearTwoYearsAgo: moment()
      .subtract(2, "years")
      .year(),
    yearThreeYearsAgo: moment()
      .subtract(3, "years")
      .year(),
    weektime: moment()
      // .subtract(1, "weeks")
      .week(), // Week Number
    day: moment()
      .locale("nl")
      .format("dddd, MMMM YYYY"),
    // .locale("NL"),
    productPercentageActual: null,
    productTarget: 10,
    productManipulate: null,
    barometerSettings: false,
    employeeSettings: false,
    timerId: null,
    dataFilter: {
      selectedDataView: "weeks",
      selectedDataWeek: moment().week(),
      selectedDataFourWeeks: Math.ceil(moment().week() / 4),
      selectedDataMonths: Number(moment().format("M")),
      selectedDataYear: moment().year()
    },
    dataFilterSaved: {
      selectedDataView: "weeks",
      selectedDataWeek: moment().week(),
      selectedDataFourWeeks: Math.ceil(moment().week() / 4),
      selectedDataMonths: Number(moment().format("M")),
      selectedDataYear: moment().year()
    },
    dyflexisDataPlanned: new Array(),
    dyflexisDataWorked: new Array(),
    employeesWorkedHours: new Array(),
    barometersCounter: 0,
    dataFilterView: null,
    dataFilterStartDate: null,
    dataFilterEndDate: null,
    dataYear: [],
    dataView: [
      {
        name: "Maand",
        id: "months"
      },
      {
        name: "4 weken",
        id: "fourweeks"
      },
      {
        name: "Week",
        id: "weeks"
      }
    ],
    months: [
      {
        name: "Januari",
        id: 1
      },
      {
        name: "Februari",
        id: 2,
        disabled: true
      },
      {
        name: "Maart",
        id: 3
      },
      {
        name: "April",
        id: 4
      },
      {
        name: "Mei",
        id: 5
      },
      {
        name: "Juni",
        id: 6
      },
      {
        name: "Juli",
        id: 7
      },
      {
        name: "Augustus",
        id: 8
      },
      {
        name: "September",
        id: 9
      },
      {
        name: "Oktober",
        id: 10
      },
      {
        name: "November",
        id: 11
      },
      {
        name: "December",
        id: 12
      }
    ],
    fourWeeks: [
      {
        name: "Week 1 t/m 4",
        id: 1
      },
      {
        name: "Week 5 t/m 8",
        id: 2
      },
      {
        name: "Week 9 t/m 12",
        id: 3
      },
      {
        name: "Week 13 t/m 16",
        id: 4
      },
      {
        name: "Week 17 t/m 20",
        id: 5
      },
      {
        name: "Week 21 t/m 24",
        id: 6
      },
      {
        name: "Week 25 t/m 28",
        id: 7
      },
      {
        name: "Week 29 t/m 32",
        id: 8
      },
      {
        name: "Week 33 t/m 36",
        id: 9
      },
      {
        name: "Week 37 t/m 40",
        id: 10
      },
      {
        name: "Week 43 t/m 44",
        id: 11
      },
      {
        name: "Week 45 t/m 48",
        id: 12
      },
      {
        name: "Week 49 t/m 52",
        id: 13
      }
    ],
    weeks: [
      {
        name: "Week 1",
        id: 1
      },
      {
        name: "Week 2",
        id: 2
      },
      {
        name: "Week 3",
        id: 3
      },
      {
        name: "Week 4",
        id: 4
      },
      {
        name: "Week 5",
        id: 5
      },
      {
        name: "Week 6",
        id: 6
      },
      {
        name: "Week 7",
        id: 7
      },
      {
        name: "Week 8",
        id: 8
      },
      {
        name: "Week 9",
        id: 9
      },
      {
        name: "Week 10",
        id: 10
      },
      {
        name: "Week 11",
        id: 11
      },
      {
        name: "Week 12",
        id: 12
      },
      {
        name: "Week 13",
        id: 13
      },
      {
        name: "Week 14",
        id: 14
      },
      {
        name: "Week 15",
        id: 15
      },
      {
        name: "Week 16",
        id: 16
      },
      {
        name: "Week 17",
        id: 17
      },
      {
        name: "Week 18",
        id: 18
      },
      {
        name: "Week 19",
        id: 19
      },
      {
        name: "Week 20",
        id: 20
      },
      {
        name: "Week 21",
        id: 21
      },
      {
        name: "Week 22",
        id: 22
      },
      {
        name: "Week 23",
        id: 23
      },
      {
        name: "Week 24",
        id: 24
      },
      {
        name: "Week 25",
        id: 25
      },
      {
        name: "Week 26",
        id: 26
      },
      {
        name: "Week 27",
        id: 27
      },
      {
        name: "Week 28",
        id: 28
      },
      {
        name: "Week 29",
        id: 29
      },
      {
        name: "Week 30",
        id: 30
      },
      {
        name: "Week 31",
        id: 31
      },
      {
        name: "Week 32",
        id: 32
      },
      {
        name: "Week 33",
        id: 33
      },
      {
        name: "Week 34",
        id: 34
      },
      {
        name: "Week 35",
        id: 35
      },
      {
        name: "Week 36",
        id: 36
      },
      {
        name: "Week 37",
        id: 37
      },
      {
        name: "Week 38",
        id: 38
      },
      {
        name: "Week 39",
        id: 39
      },
      {
        name: "Week 40",
        id: 40
      },
      {
        name: "Week 41",
        id: 41
      },
      {
        name: "Week 42",
        id: 42
      },
      {
        name: "Week 43",
        id: 43
      },
      {
        name: "Week 44",
        id: 44
      },
      {
        name: "Week 45",
        id: 45
      },
      {
        name: "Week 46",
        id: 46
      },
      {
        name: "Week 47",
        id: 47
      },
      {
        name: "Week 48",
        id: 48
      },
      {
        name: "Week 49",
        id: 49
      },
      {
        name: "Week 50",
        id: 50
      },
      {
        name: "Week 51",
        id: 51
      },
      {
        name: "Week 52",
        id: 52
      }
    ]
  }),

  created() {
    // console.log("momentCurrentYearDate: " + this.momentCurrentYearDate);
    // console.log(moment(this.momentCurrentYearDate).year());

    // Bereken begin en einddatum van de huidige week
    this.dataFilterView = "week";
    this.dataFilterStartDate = moment(this.momentCurrentYearDate)
      .day(1)
      .format("YYYY-MM-DD");
    this.dataFilterEndDate = moment(this.momentCurrentYearDate)
      .day(7)
      .format("YYYY-MM-DD");

    this.checkAvailableDates();
    this.loadUserComp();
    this.selectedDataYear = this.currentYear;
    this.dataYear.push(this.currentYear);
    this.dataYear.push(this.yearOneYearsAgo);

    // this.selectedDataFourWeeks = Math.floor(moment().week() / 4);
    // this.selectedDataMonths = Number(moment().format("M"));
  },

  mounted() {},

  beforeDestroy() {
    // Stopping the interval timer
    clearTimeout(this.timerId);
  },

  methods: {
    checkAvailableDates() {
      let currentYear = moment().year();
      let currentMonth = moment().format("M");
      let currentWeek = moment().week();
      let currentFourWeeks = Math.ceil(moment().week() / 4);
      if (this.dataFilter.selectedDataYear == currentYear) {
        this.months.forEach(month => {
          if (month.id > currentMonth) {
            month.disabled = true;
          } else {
            month.disabled = false;
          }
        });
        this.weeks.forEach(week => {
          if (week.id > currentWeek) {
            week.disabled = true;
          } else {
            week.disabled = false;
          }
        });
        this.fourWeeks.forEach(period => {
          if (period.id > currentFourWeeks) {
            period.disabled = true;
          } else {
            period.disabled = false;
          }
        });
      } else {
        this.months.forEach(month => {
          month.disabled = false;
        });
        this.weeks.forEach(week => {
          week.disabled = false;
        });
        this.fourWeeks.forEach(period => {
          period.disabled = false;
        });
      }
    },
    setSelectedDates() {
      // console.log("setSelectedDates RUNNING");

      if (this.dataFilter.selectedDataView == "weeks") {
        this.dataFilter.selectedDataFourWeeks = Math.ceil(
          this.dataFilter.selectedDataWeek / 4
        );
        this.dataFilter.selectedDataMonths = moment()
          .week(this.dataFilter.selectedDataWeek)
          .format("M");
      }
    },

    updateFilter() {
      this.dataloaded = false;
      this.dataFilterSaved = _.cloneDeep(this.dataFilter);

      let dataView = this.dataFilterSaved.selectedDataView;
      let dataYear = this.dataFilterSaved.selectedDataYear;

      this.currentYear = dataYear;
      this.momentCurrentYearDate = "01-01-" + dataYear;
      this.yearOneYearsAgo = moment("01-01-" + dataYear)
        .subtract(1, "years")
        .year();
      this.yearTwoYearsAgo = moment("01-01-" + dataYear)
        .subtract(2, "years")
        .year();
      this.yearThreeYearsAgo = moment("01-01-" + dataYear)
        .subtract(3, "years")
        .year();

      let dataNumber = null;
      let momentTime = null;
      let momentStartDate = null;
      let momentEndDate = null;

      this.allRoundEmployees = new Array();

      if (dataView == "months") {
        // Bereken begin en einddatum van de maand
        this.dataFilterView = "month";
        dataNumber = this.dataFilterSaved.selectedDataMonths;
        let selectedDate = dataYear + "-" + dataNumber + "-1";
        momentTime = moment(selectedDate);
        // console.log("selectedDate: " + selectedDate + " - momentTime: " + momentTime);

        this.dataFilterStartDate = moment(momentTime)
          .startOf("month")
          .format("YYYY-MM-DD");
        this.dataFilterEndDate = moment(momentTime)
          .endOf("month")
          .format("YYYY-MM-DD");
      } else if (dataView == "fourweeks") {
        // Bereken begin en einddatum van de geselecteerde 4 weken
        this.dataFilterView = "fourweeks";
        dataNumber = Math.ceil((this.dataFilterSaved.selectedDataFourWeeks * 4)-3);
        momentTime = moment()
          .week(dataNumber)
          .year(dataYear);
        //console.log("dataNumber: ", dataNumber)
        //console.log("momentTime: ", momentTime)
        this.dataFilterStartDate = moment(momentTime)
          .day(1)
          .format("YYYY-MM-DD");
        this.dataFilterEndDate = moment(momentTime)
          .day(28)
          .format("YYYY-MM-DD");
      } else if (dataView == "weeks") {
        // Bereken begin en einddatum van de geselecteerde week
        this.dataFilterView = "week";
        dataNumber = this.dataFilterSaved.selectedDataWeek;
        momentTime = moment()
          .week(dataNumber)
          .year(dataYear);
        this.dataFilterStartDate = moment(momentTime)
          .day(1)
          .format("YYYY-MM-DD");
        this.dataFilterEndDate = moment(momentTime)
          .day(7)
          .format("YYYY-MM-DD");
      }

      clearTimeout(this.timerId);
      this.loadSettingYear();
      this.updateBarometers();

    },

    updateEmployeeAfterSafe() {
      // console.log("Updating in Parent");
      // bus.$emit("employeeBarometerUpdate");

      const toast = this.$swal.mixin({
        toast: true,
        position: "top",
        showConfirmButton: false,
        timer: 5000
      });

      setTimeout(() => {
        toast({
          type: "success",
          title: `Nieuwe wijzigingen zijn opgeslagen`
        });
      }, 1000);
    },

    updateBarometers() {
      let timeLeft = 30000;
      this.timerId = setInterval(countdown, 1000);
      let vm = this;

      function countdown() {
        if (timeLeft == 1) {
          timeLeft = 6000;
          // console.log("Tijd om te updaten");
          vm.loadSettingYear();
          bus.$emit("employeeBarometerUpdate");
          bus.$emit("salonBarometerUpdate");
        } else {
          timeLeft--;
          vm.updateTimeToGo = timeLeft;
        }
      }
    },

    employeeBarometerSetting(item) {
      this.employeeSettings = true;
      this.selectedEmployee = Object.assign({}, item);
      this.selectedEmployeeOriginal = _.cloneDeep(item);
      if (this.activeCompData.benchmarkEmployees[item.id]) {
        this.selectedEmployeeGoal = this.activeCompData.benchmarkEmployees[
          item.id
        ];
        this.selectedEmployeeGoalOriginal = _.cloneDeep(
          this.activeCompData.benchmarkEmployees[item.id]
        );
      } else {
        this.selectedEmployeeGoal = {};
        this.selectedEmployeeGoalOriginal = {};
      }
    },

    barometerSettingBranch(item) {
      this.barometerSettings = true;
      this.selectedBranch = Object.assign({}, item);
      this.selectedBranchOriginal = _.cloneDeep(item);
    },

    loadUserComp() {
      this.userDataLoaded = false;
      let userCompanies = this.userCompanies;
      this.companies = [];
      let counter = 0

      new Promise((resolve, reject)=>{
        this.userCompanies.forEach(company=>{
          db.collection("companies").doc(company).get()
            .then(doc => {
              if (doc.data().apiItems.salonhub == true) {
                let company = {};
                company.name = doc.data().name;
                company.id = doc.id;
                if (doc.data().barometersSettings) {
                  company.barometersSettings = doc.data().barometersSettings;
                } else {
                  company.barometersSettings = {};
                }
                company.dyflexisSettings = doc.data().dyflexisSettings ? doc.data().dyflexisSettings : null;
                company.apiItems = doc.data().apiItems ? doc.data().apiItems : null;
                company.salonhubApiSettings = doc.data().salonhubApiSettings;
                company.benchmarkEmployees = doc.data().benchmarkEmployees;
                this.companies.push(company);
              }
              counter++
              if(counter == this.userCompanies.length){
                resolve()
              }
            })
        })
      })
      .then(()=>{
        // REMEMBER SELECTED COMPANY FROM LOCAL STORAGE
        if(this.userRole == 'superadmin'){
          // Super Admins have access to multiple companies 
          let selectedCompany = window.localStorage.getItem('selectedCompany')

          // Check if a selected company is set in the Local Storage
          if(selectedCompany){
            
            // Check if the selected company is an option
            let selectedCompanyIndex = _.findIndex(this.companies, { 'id': selectedCompany })

            // Selected company is an option, set activeComp
            if(selectedCompanyIndex >= 0){
              this.activeComp = this.companies[selectedCompanyIndex].id;
              this.loadBranches();
            } 
            // Selected company is no option, set first company as activeComp 
            else{
              this.activeComp = this.companies[0].id;
              window.localStorage.setItem('selectedCompany', this.companies[0].id)
              this.loadBranches();
            }
          }
          // No selected company is set 
          else {
            this.activeComp = this.companies[0].id;
            window.localStorage.setItem('selectedCompany', this.companies[0].id)
            this.loadBranches();
          }
        }

        // Regular users have 1 company, just get the first
        else {
          this.activeComp = this.companies[0].id;
          this.loadBranches();
        }
      })
    },

    loadBranches() {   
      this.dataloaded = false;
       // Set Active Company as Selected Company in Local Storage
      window.localStorage.setItem('selectedCompany', this.activeComp)

      // Load active comp data
      this.companies.forEach(data => {
        if (data.id == this.activeComp) {
          this.activeCompData = data;
          this.activeCompDataOriginal = _.cloneDeep(data);
        }
      });

      // Load branches
      this.branches = [];
      this.selectedBranches = [];

      if (this.userRole == "employee" || this.userRole == "manager") {
        if (this.userBranches.length > 0) {
          this.selectedBranches = this.userBranches;
          let branchCounter = 0;
          new Promise((resolve, reject) => {
            this.selectedBranches.forEach(branch => {
              db.collection("branches")
                .doc(branch)
                .get()
                .then(doc => {
                  let branchCollection = doc.data();
                  branchCollection.id = doc.id;
                  this.branches.push(branchCollection);
                })
                .then(() => {
                  branchCounter++;
                  if (branchCounter == this.selectedBranches.length) {
                    resolve();
                  }
                });
            });
          }).then(() => {
            if (this.selectedBranches.length < 2) {
              this.loadSelectedBranchesData();
            } 
            else {
              this.userDataLoaded = true;
              this.dataloaded = true;
              this.noData = true;
            }
          });
        } else {
          this.userDataLoaded = true;
          this.dataloaded = true;
          this.noData = true;
        }
      } else {
        db.collection("branches")
          .where("compId", "==", this.activeComp)
          .get()
          .then(snap => {
            snap.forEach(doc => {
              let branchCollection = doc.data();
              branchCollection.id = doc.id;
              this.branches.push(branchCollection);
              this.selectedBranches.push(doc.id);
              // this.selectedBranchesSalonhub.push(doc.data().branchNameSalonhub);
            });
          })
          .then(() => {
            if (this.selectedBranches.length < 2) {
              this.loadSelectedBranchesData();
            } 
            else {
              this.userDataLoaded = true;
              this.dataloaded = true;
              this.noData = true;
            }
          });
      }
    },

    loadSelectedBranchesData() {
      this.dataloaded = false;
      this.revenuePerTicket = {}
      this.selectedBranchesData = [];
      this.selectedBranchesSalonhub = [];
      this.selectedBranchesOriginal = _.cloneDeep(this.selectedBranches);

      if (this.selectedBranches.length != 0) {
        new Promise((resolve, reject) => {
          let branchCounter = 0;
          this.selectedBranches.forEach(item => {
            db.collection("branches")
              .doc(item)
              .get()
              .then(doc => {
                branchCounter++;
                let branch = doc.data();
                branch.id = doc.id;
                this.selectedBranchesData.push(branch);
                this.selectedBranchesSalonhub.push(
                  doc.data().branchNameSalonhub
                );
                if (branchCounter === this.selectedBranches.length) {
                  resolve();
                }
              });
          });
        }).then(() => {
          this.noData = false;
          this.userDataLoaded = true;
          this.loadSettingYear();
          this.updateBarometers();
        });
      } else {
        this.userDataLoaded = true;
        this.dataloaded = true;
        this.noData = true;
        // Stopping the interval timer
        clearTimeout(this.timerId);
      }
    },

    loadSettingYear() {
      // Laad alle medewerkers binnen
      // console.log("Load Year settings");
      this.barometersCounter = 0
      axios
        .get(`https://public.salonhub.nl/current/${this.activeCompData.salonhubApiSettings.customer}/${this.activeCompData.salonhubApiSettings.username}/${this.activeCompData.salonhubApiSettings.md5}/admin/settings/searchEmployees?query=:active`)
        .then(response => {
          // console.log("Employee response: ", response)
          this.allEmployees = null;
          this.allEmployees = response.data;
        })
        .then(() => {
          // #1 Data voor doelen per branch ophalen
          let branchCounter = 0;
          new Promise((resolve)=>{ 
            this.selectedBranchesData.forEach(branchData=>{
              //Get Employee Report
              let apiUrlEmployeeReports = `https://public.salonhub.nl/current/${this.activeCompData.salonhubApiSettings.customer}/${this.activeCompData.salonhubApiSettings.username}/${this.activeCompData.salonhubApiSettings.md5}/salon/${branchData.branchNameSalonhub}/getReport?name=Reports.Employees.Performance&parameters={"period":"${this.dataFilterView}","from":"${this.dataFilterStartDate}","to":"${this.dataFilterEndDate}"}`;
              axios.get(apiUrlEmployeeReports)
              .then(response => {
                // console.log("employee response: ", response)
                this.reportEmployee[branchData.branchNameSalonhub] = [];
                this.reportEmployee[branchData.branchNameSalonhub].push(response.data);
              })
              .then(() => {
                // console.log("branchData.branchNameSalonhub: ", branchData.branchNameSalonhub)
                this.reportEmployee[branchData.branchNameSalonhub][0].data.employees.forEach(employee=>{
                  this.allEmployees.forEach(o => {
                    if(employee.name == o.name) { //Wanneer de naam overeenkomt met ID.
                      employee.id = o.id;
                      // console.log("Ik match ", o.name, o.id);
                    }
                  });
                })      
              })
              .then(()=> {
                if(branchData.barometersSettings.useManualGoals){ // Manual Goals Data gebruiken (activeBranch.barometersSettings.useManualGoals aan staat)
                  this.SettingYearData[branchData.branchNameSalonhub] = new Array();
                  let data = {
                    fourweeks: new Array(13).fill().map((e,i) => {return {fourweek: i +1, products: 0, total: 0, treatments: 0}}),
                    months: new Array(12).fill().map((e,i) => {return {month: String(i +1), products: 0, total: 0, treatments: 0}}),
                    quarters: new Array(4).fill().map((e,i) => {return {quarter: i +1, products: 0, total: 0, treatments: 0 }}),
                    weeks: new Array(52).fill().map((e,i) => {return {week: String(i +1), products: 0, total: 0, treatments: 0}})
                  };

                  // Set Fourweek goals based on manual month goals
                  data.fourweeks.forEach((fourweek)=>{
                    let month = moment().day("Monday").week(fourweek.fourweek*4).format("M");
                    if(branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear] && branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][month]){
                      fourweek.treatments = Number((branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][month] / 1.08).toFixed(0));
                      fourweek.total = Number((branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][month] / 1.08).toFixed(0));
                    }
                    else{
                      fourweek.treatments = 0;
                      fourweek.total = 0;
                    }
                    if(branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear] && branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][month]){
                      fourweek.products = Number((branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][month] / 1.08).toFixed(0));
                      fourweek.total = branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][month] ? (fourweek.total + (branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][month] / 1.08)) : fourweek.total;
                      fourweek.total = Number(fourweek.total.toFixed(0));
                    }
                    else{
                      fourweek.products = 0;
                      fourweek.total = 0;
                    }
                  })

                  // Set Month goals based on manual month goals
                  data.months.forEach((month)=>{
                    if(branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear] && branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][month.month]){
                      month.treatments = branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][month.month];
                      month.total = branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][month.month];
                    }
                    else{
                      month.treatments = 0;
                      month.total = 0;
                    }

                    if(branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear] && branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][month.month]){
                      month.products = branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][month.month];
                      month.total = branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][month.month] ? month.total + branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][month.month] : month.total;
                    }
                    else{
                      month.products = 0;
                      month.total = 0;
                    }
                  })

                  // Set Quarter goals based on manual month goals
                  data.quarters.forEach((quarter)=>{
                    if(quarter.quarter == 1){
                      quarter.treatments = branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear] && branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][1] ? branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][1] : 0;
                      quarter.treatments = branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear] && branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][2] ? branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][2] + quarter.treatments : quarter.treatments;
                      quarter.treatments = branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear] && branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][3] ? branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][3] + quarter.treatments : quarter.treatments;

                      quarter.products = branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear] && branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][1] ? branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][1] : 0;
                      quarter.products = branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear] && branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][2] ? branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][2] + quarter.products : quarter.products;
                      quarter.products = branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear] && branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][3] ? branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][3] + quarter.products : quarter.products;
                      quarter.total = quarter.treatments + quarter.products;
                    }
                    else if(quarter.quarter == 2){
                      quarter.treatments = branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear] && branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][4] ? branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][4] : 0;
                      quarter.treatments = branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear] && branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][5] ? branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][5] + quarter.treatments : quarter.treatments;
                      quarter.treatments = branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear] && branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][6] ? branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][6] + quarter.treatments : quarter.treatments;

                      quarter.products = branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear] && branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][4] ? branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][4] : 0;
                      quarter.products = branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear] && branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][5] ? branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][5] + quarter.products : quarter.products;
                      quarter.products = branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear] && branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][6] ? branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][6] + quarter.products : quarter.products;
                      quarter.total = quarter.treatments + quarter.products;
                    }
                    else if(quarter.quarter == 3){
                      quarter.treatments = branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear] && branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][7] ? branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][7] : 0;
                      quarter.treatments = branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear] && branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][8] ? branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][8] + quarter.treatments : quarter.treatments;
                      quarter.treatments = branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear] && branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][9] ? branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][9] + quarter.treatments : quarter.treatments;

                      quarter.products = branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear] && branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][7] ? branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][7] : 0;
                      quarter.products = branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear] && branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][8] ? branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][8] + quarter.products : quarter.products;
                      quarter.products = branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear] && branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][9] ? branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][9] + quarter.products : quarter.products;
                      quarter.total = quarter.treatments + quarter.products;
                    }
                    else if(quarter.quarter == 4){
                      quarter.treatments = branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear] && branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][10] ? branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][10] : 0;
                      quarter.treatments = branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear] && branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][11] ? branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][11]  + quarter.treatments : quarter.treatments;
                      quarter.treatments = branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear] && branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][12] ? branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][12]  + quarter.treatments : quarter.treatments;

                      quarter.products = branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear] && branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][10] ? branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][10] : 0;
                      quarter.products = branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear] && branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][11] ? branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][11] + quarter.products : quarter.products;
                      quarter.products = branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear] && branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][12] ? branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][12] + quarter.products : quarter.products;
                      quarter.total = quarter.treatments + quarter.products;
                    }
                  })
  
                  // Set Week goals based on manual month goals
                  data.weeks.forEach((week)=>{
                    let month = moment().day("Monday").week(week.week).format("M");
                    // console.log("month: ", month, "Week("+ week.week+")")
                    if(branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear] && branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][month]){
                      week.treatments = Number((branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][month] / 4.33).toFixed(0));
                      week.total = Number((branchData.barometersSettings.manualGoalsTreatments[this.dataFilterSaved.selectedDataYear][month] / 4.33).toFixed(0));
                    }
                    else{
                      week.treatments = 0;
                      week.total = 0;
                    }
                    if(branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear] && branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][month]){
                      week.products = Number((branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][month] / 4.33).toFixed(0));
                      week.total = branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][month] ? (week.total + (branchData.barometersSettings.manualGoalsProducts[this.dataFilterSaved.selectedDataYear][month]/ 4.33)) : week.total;
                      week.total = Number(week.total.toFixed(0));
                    }
                    else{
                      week.products = 0;
                      week.total = 0;
                    }
                  })
                  
                  this.SettingYearData[branchData.branchNameSalonhub] = [];
                  this.SettingYearData[branchData.branchNameSalonhub].push({data:data});

                  branchCounter++
                  if(branchCounter == this.selectedBranchesData.length){
                    resolve()
                  }
                }
                else{ // Data Vorig jaar binnenhalen uit Salonhub
                  // console.log("Gegevens vorig jaar binnenladen: ", branchData.branchNameSalonhub);
                  let apiUrlLastYearReports = `https://public.salonhub.nl/current/${this.activeCompData.salonhubApiSettings.customer}/${this.activeCompData.salonhubApiSettings.username}/${this.activeCompData.salonhubApiSettings.md5}/salon/${branchData.branchNameSalonhub}/getReport?name=Reports.Financial.Overview&parameters={"period":"year","year":${this.yearOneYearsAgo},"from":"${this.yearOneYearsAgo}-01-01","to":"${this.yearOneYearsAgo}-12-31","previous":{"year":${this.yearTwoYearsAgo},"from":"${this.yearTwoYearsAgo}-01-01","to":"${this.yearTwoYearsAgo}-12-31"},"next":{"year":${this.yearOneYearsAgo},"from":"${this.yearOneYearsAgo}-01-01","to":"${this.yearOneYearsAgo}-12-31"},"employee":"","group":"","unit":""}`;

                  axios.get(apiUrlLastYearReports)
                    .then(response => {
                      // console.log(response.data);
                      this.SettingYearData[branchData.branchNameSalonhub] = [];
                      this.SettingYearData[branchData.branchNameSalonhub].push(response.data);

                      branchCounter++
                      if(branchCounter == this.selectedBranchesData.length){
                        resolve()
                      }
                    })
                    .catch(error => {
                      this.dataloaded = true;
                      this.loadingError = "Er is iets fout gegaan bij het binnenhalen van Salonhub. Probeer het opnieuw.";
                      console.error("Error gegevens vorig jaar binnenladen: ", error);
                      
                      if(branchCounter == this.selectedBranchesData.length){
                        resolve()
                      }
                    });
                }
              })
            })
          })
          .then(()=>{
            // console.log("Data voor Branches Doelen binnengehaald")

            let counter = 0;
            new Promise((resolve)=>{
              this.selectedBranchesData.forEach(branchData=>{
                // console.log("Gegevens dit jaar binnenladen: ", branchData.branchNameSalonhub);

                axios
                  .get(
                    "https://public.salonhub.nl/current/" +
                      this.activeCompData.salonhubApiSettings.customer +
                      "/" +
                      this.activeCompData.salonhubApiSettings.username +
                      "/" +
                      this.activeCompData.salonhubApiSettings.md5 +
                      "/salon/" +
                      branchData.branchNameSalonhub +
                      `/getReport?name=Reports.Financial.Overview&parameters={"period":"year","year":${
                        this.currentYear
                      },"from":"${this.currentYear}-01-01","to":"${
                        this.currentYear
                      }-12-31","previous":{"year":${
                        this.yearTwoYearsAgo
                      },"from":"${this.yearTwoYearsAgo}-01-01","to":"${
                        this.yearTwoYearsAgo
                      }-12-31"},"next":{"year":${
                        this.yearOneYearsAgo
                      },"from":"${this.yearOneYearsAgo}-01-01","to":"${
                        this.yearOneYearsAgo
                      }-12-31"},"employee":"","group":"","unit":""}`
                  )
                  .then(response => {
                    this.ThisYearData[branchData.branchNameSalonhub] = [];
                    this.ThisYearData[branchData.branchNameSalonhub].push(response.data);
                  })
                  .then(()=>{
                    
                    new Promise((res)=>{
                      if(this.activeCompDataOriginal.barometersSettings.showCreativeBarometer || this.activeCompDataOriginal.barometersSettings.showWeekGoalColorsBarometer){
                        // Kleuringen binnenhalen
                        let apiUrlColor = `https://public.salonhub.nl/current/${this.activeCompData.salonhubApiSettings.customer}/${this.activeCompData.salonhubApiSettings.username}/${this.activeCompData.salonhubApiSettings.md5}/salon/${branchData.branchNameSalonhub}/getReport?name=Reports.Financial.Revenue&parameters={"period":"${this.dataFilterView}","from":"${this.dataFilterStartDate}","to":"${this.dataFilterEndDate}"}`;
                        axios.get(apiUrlColor)
                        .then(response => {
                          this.Revenue[branchData.branchNameSalonhub] = [];
                          this.Revenue[branchData.branchNameSalonhub].push(response.data);
                          res()
                        })
                      }
                      else{
                        res()
                      }
                    })
                    .then(() => {
                      let barometersCounter = 0;
                      new Promise((res,rej)=>{
                        // #1 WeekGoalProductsBarometer
                        if(this.activeCompDataOriginal.barometersSettings.showWeekGoalProductsBarometer){
                          this.loadProductData([branchData.branchNameSalonhub]).then(result => {
                            // console.log("loadProductData Completed: ", this.barometersCounter)
                            barometersCounter++
                            if(barometersCounter == 8){res()}
                          })
                        } 
                        else{
                          // console.log("No loadProductData: ", this.barometersCounter)
                          barometersCounter++
                          if(barometersCounter == 8){res()}
                        }

                        // #2 Appointments
                        if(this.activeCompDataOriginal.barometersSettings.showAppointments){
                          this.loadAppointmentData(branchData.branchNameSalonhub).then(result => {
                            // console.log("loadAppointmentData Completed: ", this.barometersCounter)
                            barometersCounter++
                            if(barometersCounter == 8){res()}
                          })
                        } 
                        else{
                          // console.log("No loadAppointmentData: ", this.barometersCounter)
                          barometersCounter++
                          if(barometersCounter == 8){res()}
                        }
                        
                        // #3 WeekGoalTreatmentsBarometer
                        if(this.activeCompDataOriginal.barometersSettings.showWeekGoalTreatmentsBarometer || this.activeCompDataOriginal.barometersSettings.showWeekGoalBarometer){
                          this.loadTreatmentData(branchData.branchNameSalonhub).then(result => {
                            // console.log("loadTreatmentData Completed: ", this.barometersCounter)
                            barometersCounter++
                            if(barometersCounter == 8){res()}
                          })
                        } 
                        else{
                          // console.log("No loadTreatmentData: ", this.barometersCounter)
                          barometersCounter++
                          if(barometersCounter == 8){res()}
                        }
                        // #4 MonthBarometer
                        if(this.activeCompDataOriginal.barometersSettings.showMonthBarometer){
                          this.load4weeksTotal(branchData.branchNameSalonhub).then(result => {
                            // console.log("load4weeksTotal Completed: ", this.barometersCounter)
                            barometersCounter++
                            if(barometersCounter == 8){res()}
                          })
                        } 
                        else{
                          // console.log("No load4weeksTotal: ", this.barometersCounter)
                          barometersCounter++
                          if(barometersCounter == 8){res()}
                        }

                        // #5 WeekGoalColorsBarometer
                        if(this.activeCompDataOriginal.barometersSettings.showWeekGoalColorsBarometer){
                          this.loadColours(branchData.branchNameSalonhub).then(result => {
                            // console.log("loadColours Completed: ", this.barometersCounter)
                            barometersCounter++
                            if(barometersCounter == 8){res()}
                          })
                        } 
                        else{
                          // console.log("No load4weeksTotal: ", this.barometersCounter)
                          barometersCounter++
                          if(barometersCounter == 8){res()}
                        }

                        // #6 CreativeBarometer
                        if(this.activeCompDataOriginal.barometersSettings.showCreativeBarometer){
                          this.loadCreative(branchData.branchNameSalonhub).then(result => {
                            // console.log("loadCreative Completed: ", this.barometersCounter)
                            barometersCounter++
                            if(barometersCounter == 8){res()}
                          })
                        }
                        else{
                          // console.log("No loadCreative: ", this.barometersCounter)
                          barometersCounter++
                          if(barometersCounter == 8){res()}
                        }

                        // #7 CustomProductData
                        if(this.activeCompDataOriginal.barometersSettings.showCustomProductData){
                          this.loadCustomProductData(branchData.branchNameSalonhub).then(result => {
                            // console.log("loadCustomProductData Completed: ", this.barometersCounter)
                            barometersCounter++
                            if(barometersCounter == 8){res()}
                          })
                        } 
                        else{
                          // console.log("No loadCustomProductData: ", this.barometersCounter)
                          barometersCounter++
                          if(barometersCounter == 8){res()}
                        }
                        
                        // #8 RevenuePerTicketBarometer
                        if(this.activeCompDataOriginal.barometersSettings.showRevenuePerTicketBarometer){
                          this.loadRevenuePerTicket(branchData.branchNameSalonhub).then(result => {
                            // console.log("loadRevenuePerTicket Completed: ", this.barometersCounter)
                            barometersCounter++
                            if(barometersCounter == 8){res()}
                          })
                        }
                        else{
                          // console.log("No loadRevenuePerTicket: ", this.barometersCounter)
                          barometersCounter++
                          if(barometersCounter == 8){res()}
                        }
                      })
                      .then(() => {
                        // console.log("Salon " + branchData.branchNameSalonhub + " alle functies uitgevoerd");
                        counter++;
                        if (counter == this.selectedBranchesSalonhub.length) {
                          resolve();
                        }
                      });
                    })
                  })

                  .catch(error => {
                    this.dataloaded = true;
                    this.loadingError = "Er is iets fout gegaan bij het binnenhalen van Salonhub. Probeer het opnieuw.";
                    console.error("Error gegevens dit jaar binnenladen: ", error);
                  })
              })
            })
            .then(() => {
              this.loadingError = null;
              // console.log("Klaar met laden deel 1");
            })
            .then(() => {
              if(this.activeCompDataOriginal.barometersSettings.showEmployeeBarometerOnlyToManager == false || this.userRole != 'employee'){
                this.loadEmployeeProduct();
              } 
              else {
                // console.log("Echt klaar met laden(Zonder employees");

                bus.$emit("salonBarometerUpdate");
                this.employeeloaded = true;
                if(this.activeCompDataOriginal.barometersSettings.showAllround){
                  this.loadAllround(); //Alle data is binnen we rekenen 1 malig alles uit.
                }
                this.dataloaded = true;
                this.loadingError = null;
              }
              
            });
            
          })
        })
        .catch(error => {
          this.dataloaded = true;
          this.loadingError = "Er is iets fout gegaan bij het binnenhalen van Salonhub. Probeer het opnieuw.";
          console.error("Gegevens vorig jaar binnenladen: ", error);
        });               
    },
    
    // https://public.salonhub.nl/current/hairbeautycomp/joe/47a9c814582f4b77969f1878d1ca82ae/admin/settings/searchEmployees?query=,active
    // https://public.salonhub.nl/current/hairbeautycomp/joe/47a9c814582f4b77969f1878d1ca82ae/salon/demeern/getReport?name=Reports.Financial.Revenue&parameters={"period":"week","from":"2018-09-24","to":"2018-09-30"}
    // https://public.salonhub.nl/current/hairbeautycomp/joe/47a9c814582f4b77969f1878d1ca82ae/salon/demeern/getReport?name=Reports.Financial.Revenue&parameters={"period":"week","from":"2018-10-01","to":"2018-09-30"}
    // https://public.salonhub.nl/current/hairbeautycomp/joe/47a9c814582f4b77969f1878d1ca82ae/salon/demeern/getReport?name=Reports.Financial.Revenue&parameters={"period":"day","day":"2018-09-29","from":"2018-09-29","to":"2018-09-29"}
    // https://public.salonhub.nl/current/hairbeautycomp/joe/47a9c814582f4b77969f1878d1ca82ae/salon/harmelen/getReport?name=Reports.Financial.Revenue&parameters={"period":"day","day":"2018-10-02","from":"2018-10-02","2018-10-02"}

    
   async getDyflexisDataWorked(){
      this.dyflexisDataWorked = new Array();
      let customParams = {
        month: this.dataFilterSaved.selectedDataMonths,
        year: this.dataFilterSaved.selectedDataYear,
        page: 0
      };

      // let config = {
      //   method: 'get',
      //   url: `https://app.planning.nu/degruyterhair/api/v0/worked?month=${customParams.month}&year=${customParams.year}&page=${customParams.page}`,
      //   headers: {
      //     'X-Dyflexis-AuthToken': this.activeCompData.dyflexisSettings.api,
      //   }
      // };

      let config = {
        method: 'post',
        url: 'https://dyflexis.hogans.nl/worked',
        data: {
          'month': customParams.month,
          'year': customParams.year,
          'page': customParams.page,
          'token': this.activeCompData.dyflexisSettings.api,
        }
      };

      let continueDyflexis = true;

      while(continueDyflexis) {
        // code block to be executed
        await axios(config)
        .then(response => {
          // console.log("Dyflexis data Worked page", customParams.page + ":", response);
          this.dyflexisDataWorked = this.dyflexisDataWorked.concat(response.data);
          if(response.data.length < 500){
            continueDyflexis = false;
            return
          }
          else{
            customParams.page++
          }
        })
        .catch(error=> {
          // console.error("Error loading Dyflexis worked data: ", error);
          continueDyflexis = false;
          return
        });
      }
    },

    async getDyflexisDataPlanned(){
      this.dyflexisDataPlanned = new Array();
      let customParams = {
        month: this.dataFilterSaved.selectedDataView == 'weeks' ? moment().isoWeek(this.dataFilterSaved.selectedDataWeek).startOf('week').format("M") : this.dataFilterSaved.selectedDataMonths,
        year: this.dataFilterSaved.selectedDataYear,
        week:  this.dataFilterSaved.selectedDataWeek,
        page: 0
      };

      let loadNextMonth = false

      if(this.dataFilterSaved.selectedDataView == 'weeks'){
        let startMonthOfWeek = moment().isoWeek(this.dataFilterSaved.selectedDataWeek).startOf('week').format("M")
        let endMonthOfWeek = moment().isoWeek(this.dataFilterSaved.selectedDataWeek).endOf('week').format("M")
        console.log("startMonthOfWeek: ", startMonthOfWeek)
        console.log("endMonthOfWeek: ", endMonthOfWeek)
        if(endMonthOfWeek > customParams.month ){ // Volgende maand ook laden
          loadNextMonth = true;
        }
      }
   

      // let config = {
      //   method: 'get',
      //   url: `https://app.planning.nu/degruyterhair/api/v0/planned?month=${customParams.month}&year=${customParams.year}&page=${customParams.page}`,
      //   headers: {
      //     'X-Dyflexis-AuthToken': this.activeCompData.dyflexisSettings.api, 
      //   },
      //   useCredentails: true
      // };

      let config = {
        method: 'post',
        url: 'https://dyflexis.hogans.nl/planned',
        data: {
          'month': customParams.month,
          'year': customParams.year,
          'page': customParams.page,
          'token': this.activeCompData.dyflexisSettings.api,
        }
      };

      let continueDyflexis = true;

      while(continueDyflexis) {
        // code block to be executed
        console.log("config.data.month: ", config.data.month)
        await axios(config)
        .then(response => {
          // ("Dyflexis data Planned page", customParams.page + ":", response.data);
          this.dyflexisDataPlanned = this.dyflexisDataPlanned.concat(response.data);
          if(response.data.length < 500){
            if(loadNextMonth){
              console.log("Load next month")
              loadNextMonth = false;
              customParams.page = 0
              config.data.month = Number(config.data.month) + 1
            }
            else{
              continueDyflexis = false;
              return
            }   
          }
          else{
            customParams.page++
          }
        })
        .catch(error=> {
          console.error("Error loading Dyflexis planned data: ", error);
          continueDyflexis = false;
          return
        });
      }
    },

    async loadEmployeesDyflexisData(){
      // console.log("loadEmployeesDyflexisDataloadEmployeesDyflexisData")
      let counter = 0;
      await new Promise((resolve)=>{
        this.getDyflexisDataWorked().then(()=>{
          counter++
          if(counter == 2){
            resolve()
          }
        })
        this.getDyflexisDataPlanned().then(()=>{
          counter++
          if(counter == 2){
            resolve()
          }
        })
      })
      .then(()=>{
        // ("Dyflexis is klaar")
        this.employeesWorkedHours = new Object();
        let branches = new Object();

        this.dyflexisDataWorked.forEach(data=>{ // Duration omzetten naar Number om op te tellen
          data.duration = Number(data.duration);
          if(!branches[data.office_id]){
            branches[data.office_id] = {
              dataWorked: new Array(),
              dataPlanned: new Array()
            }
          }
          branches[data.office_id].dataWorked.push(data);
          
        });

        this.dyflexisDataPlanned.forEach(data=>{ // Duration omzetten naar Number om op te tellen
          data.duration = Number(data.duration);
          if(!branches[data.office_id]){
            branches[data.office_id] = {
              dataWorked: new Array(),
              dataPlanned: new Array()
            }
          }
          branches[data.office_id].dataPlanned.push(data);
        });

        
        new Promise((resolve)=>{
          let counter = 0;
          for (const [key] of Object.entries(branches)) {

            // Gewerkte uren per maand
            // let employeeSumMonthWeek = Array.from(this.dyflexisDataWorked.reduce((m, {user_id, duration}) => m.set(user_id, (m.get(user_id) || 0) + duration), new Map), ([user_id, duration]) => ({user_id, duration}));

            // Gewerkte uren per week per branch
            branches[key].selectedWeekHoursWorked = new Array();
            branches[key].dataWorked.forEach(data=>{
              if(this.dataFilterSaved.selectedDataView == 'weeks'){
                 if(data.start_date >= moment().week(this.dataFilterSaved.selectedDataWeek).startOf("week").format("YYYY-MM-DD HH:mm:ss") && data.end_date <= moment().week(this.dataFilterSaved.selectedDataWeek).endOf("week").format("YYYY-MM-DD HH:mm:ss")){
                  branches[key].selectedWeekHoursWorked.push(data)
                }
              }
              else if(this.dataFilterSaved.selectedDataView == 'months'){
                if(data.start_date >= moment(this.dataFilterSaved.selectedDataMonths, "M").startOf("month").format("YYYY-MM-DD HH:mm:ss") && data.end_date <= moment(this.dataFilterSaved.selectedDataMonths, "M").endOf("month").format("YYYY-MM-DD HH:mm:ss")){
                  branches[key].selectedWeekHoursWorked.push(data)
                }
              }
            })
            branches[key].employeeSumWeekWorked = Array.from(branches[key].selectedWeekHoursWorked.reduce((m, {user_id, duration}) => m.set(user_id, (m.get(user_id) || 0) + duration), new Map), ([user_id, duration]) => ({user_id, duration}));
            
            // Geplande uren per maand
            // let employeeSumMonthPlanned = Array.from(this.dyflexisDataPlanned.reduce((m, {user_id, duration}) => m.set(user_id, (m.get(user_id) || 0) + duration), new Map), ([user_id, duration]) => ({user_id, duration}));

            // Geplande uren per week

            branches[key].selectedWeekHoursPlanned = new Array();
            branches[key].dataPlanned.forEach(data=>{
              if(this.dataFilterSaved.selectedDataView == 'weeks'){
                if(data.start_date >= moment().week(this.dataFilterSaved.selectedDataWeek).startOf("week").format("YYYY-MM-DD HH:mm:ss") && data.end_date <= moment().week(this.dataFilterSaved.selectedDataWeek).endOf("week").format("YYYY-MM-DD HH:mm:ss") && data.end_date <= moment().endOf("day").format("YYYY-MM-DD HH:mm:ss")){
                  branches[key].selectedWeekHoursPlanned.push(data);
                }
              }
              else if(this.dataFilterSaved.selectedDataView == 'months'){
                console.log("view is months")
                if(data.start_date >= moment(this.dataFilterSaved.selectedDataMonths, "M").startOf("month").format("YYYY-MM-DD HH:mm:ss") && data.end_date <= moment().endOf("day").format("YYYY-MM-DD HH:mm:ss")){
                  branches[key].selectedWeekHoursPlanned.push(data)
                }
              }
            })
            branches[key].employeeSumWeekPlanned = Array.from(branches[key].selectedWeekHoursPlanned.reduce((m, {user_id, duration}) => m.set(user_id, (m.get(user_id) || 0) + duration), new Map), ([user_id, duration]) => ({user_id, duration}));
            counter++
            if(counter == _.size(branches)){
              resolve()
            }
          }
        })
        .then(()=>{
          // console.log("PRE SNEAKPEAK BRANCHES: ", branches)
          this.employeesWorkedHours = new Object();

          this.selectedBranchesData.forEach(branch=>{
            this.employeesWorkedHours[branch.id] = {
              type: "worked",
              data: new Array()
            }
          })

          for (const [key] of Object.entries(branches)) {
            let branch = _.find(this.selectedBranchesData, function(o) { return o.barometersSettings.dyflexisBranchId == key });
            if(branch && branch.id){
              if(branches[key].employeeSumWeekWorked && branches[key].employeeSumWeekWorked.length > 0  && this.dataFilterSaved.selectedDataWeek != moment().isoWeek() ){
                this.employeesWorkedHours[branch.id].type = "worked";
                this.employeesWorkedHours[branch.id].data = branches[key].employeeSumWeekWorked;
              }
              else{
                this.employeesWorkedHours[branch.id].type = "planned";
                this.employeesWorkedHours[branch.id].data = branches[key].employeeSumWeekPlanned;
              }
            }
          }
        })
        
      })
      .then(()=>{
        this.selectedBranchesData.forEach(branch=>{
          this.reportEmployee[branch.branchNameSalonhub][0].data.employees.forEach(salonhubEmployee=>{
            if(this.activeCompData.benchmarkEmployees[salonhubEmployee.id]){
              // console.log("Employee gevonden:")
              if(this.activeCompData.benchmarkEmployees[salonhubEmployee.id].dyflexisUserId){
                salonhubEmployee.dyflexis = true;

                // console.log("Employee dyflexisUserId:", String(this.activeCompData.benchmarkEmployees[salonhubEmployee.id].dyflexisUserId))
                
                let workedHours = _.find(this.employeesWorkedHours[branch.id].data, {'user_id': String(this.activeCompData.benchmarkEmployees[salonhubEmployee.id].dyflexisUserId)})
                // console.log("worked hours: ", workedHours)
                salonhubEmployee.dyflexisHours = workedHours ? workedHours.duration / 60 : 0;
                salonhubEmployee.dyflexisMinutes = workedHours ? workedHours.duration : 0;

              }
              else{
                salonhubEmployee.dyflexis = false;
              }
            }
          })
        })
      })
      
      return 
    },

  
    async loadEmployeeProduct() {
      
      // PRODUCT PER MEDEWERKER

      // 1. Matchen en samenbrengen van Salon Naam en ID
      // 2. Dynamisch binnen halen van bijhorende salon Data.
      // 3. Order in weeknummers maken volgens DESC.

      // console.log("Start laden EmployeeProduct");
      this.employeeloaded = false;
      this.productEmployee = [];
      let weeknumber = Number(moment().format("w"));
      let financeCounter = 0;
      
      
      await new Promise((resolve)=>{
        if(this.activeCompData.barometersSettings.dyflexis && this.activeCompData.apiItems.dyflexis && this.activeCompData.dyflexisSettings && this.activeCompData.dyflexisSettings.api){
          // console.log("Dyflexis data laden.")
          this.loadEmployeesDyflexisData().then(()=>{
            resolve()
          });
        }
        else{
          resolve()
          // console.log("Geen juiste Dyflexis gegevens.")
        }
      })
      // console.log("Doorgaan met laden van data")

      

      
      
      new Promise((resolve) => {
        this.selectedBranchesSalonhub.forEach(selectedBranch =>{

          let financeCounterTwo = 0;
          // Start reportEmployeeCounter Promise
          new Promise((resolve) => {
  
            this.reportEmployee[selectedBranch][0].data.employees.forEach((employeeData, index) =>{

              // Start All Employee Promise
              new Promise((resolve) => {

                let reportEmployeeCounter = 0

                this.allEmployees.forEach(employee => {
                  // Wanneer de naam overeenkomt met ID.

                  if(this.reportEmployee[selectedBranch][0].data.employees[index].id == employee.id){
                    
                    // console.log("Ik match ", this.reportEmployee[selectedBranch][0].data.employees[index].name, selectedBranch , o.name);
                
                    axios
                      .get(
                        "https://public.salonhub.nl/current/" +
                          this.activeCompData.salonhubApiSettings.customer +
                          "/" +
                          this.activeCompData.salonhubApiSettings.username +
                          "/" +
                          this.activeCompData.salonhubApiSettings.md5 +
                          "/salon/" +
                          selectedBranch +
                          `/getReport?name=Reports.Sales.Products&parameters={"period":"${this.dataFilterView}","from":"${
                            this.dataFilterStartDate
                          }","to":"${this.dataFilterEndDate}","employee":"${
                            employee.id
                          }"}`
                      )
                      .then(response => {
                        // Opsplitsen van persoonlijke productdata
                        // console.log("RESPONSE: ", this.reportEmployee[selectedBranch][0].data.employees[index].name, selectedBranch, response)
                        if(response.data.data){
                          this.productEmployee.push({
                            id: this.reportEmployee[selectedBranch][0].data.employees[index].id,
                            name: this.reportEmployee[selectedBranch][0].data.employees[index].name,
                            branch: selectedBranch,
                            productcount: response.data.data.totals.count
                          });
                        } 
                        else{
                          this.productEmployee.push({
                            id: this.reportEmployee[selectedBranch][0].data.employees[index].id,
                            name: this.reportEmployee[selectedBranch][0].data.employees[index].name,
                            branch: selectedBranch,
                            productcount: 0
                          });
                        }
                      })
                      .then(() => {
                        reportEmployeeCounter++;

                 
                        if(reportEmployeeCounter == this.allEmployees.length) {
                          // console.log("reportEmployeeCounter Resolved");
                          resolve();
                        }
                      })
                      .catch(error => {
                        console.error("Error binnenhalen reportEmployee data ", this.reportEmployee[selectedBranch][0].data.employees[index].name, ": ", error);
                        financeCounterTwo++;
                        if(financeCounterTwo == this.allEmployees.length){
                          // console.log("financeCounterTwo Resolved");
                          resolve();
                        }
                      });

                  } 
                  else {
                    // console.log("Ik Match niet")
                    reportEmployeeCounter++;
                    if(reportEmployeeCounter == this.allEmployees.length) {
                      // console.log("reportEmployeeCounter Resolved");
                      resolve();
                    }
                  }
                })
              })
              // End All Employee Promise 

              .then(()=>{
                financeCounterTwo++;
                if(financeCounterTwo == this.reportEmployee[selectedBranch][0].data.employees.length) {
                  resolve();
                }
              })
            })
          })
          // End reportEmployeeCounter Promise 

          .then(() => {
            // console.log("financeCounter Resolved: ", this.selectedBranchesSalonhub.length);
            financeCounter++;
            if (financeCounter == this.selectedBranchesSalonhub.length) {
              resolve();
            }
          })
          
        })
      })
      .then(() => {
        // console.log("Klaar met laden EmployeeProduct");
        this.employeeloaded = false;
        this.loadEmployeeFinance(); //Alle data is binnen we rekenen 1 malig alles uit.
        this.dataloaded = false;
        this.loadingError = null;
      })
      .catch(error => {
        this.dataloaded = true;
        this.loadingError =
          "Er is iets fout gegaan bij het binnenhalen van Salonhub. Probeer het opnieuw.";
        console.error("Error met laden deel 2");
      });
    },

    loadEmployeeFinance() {
      // console.log("Start laden Employee Finance");
      this.employeeloaded = false;

      //Product per persoon

      /*
          1. Matchen en samenbrengen van Salon Naam en ID
          2. Dynamisch binnen halen van bijhorende salon Data.
          3. Order in weeknummers maken volgens DESC.
        */

      this.financeEmployee = [];
      var weeknumber = Number(moment().format("w"));

      let financeCounter = 0;

      new Promise((resolve, reject) => {
        this.selectedBranchesSalonhub.forEach(selectedBranch=>{
          // console.log("branchData.branchNameSalonhub: ", selectedBranch)

        
          let financeCounterTwo = 0;

          new Promise((resolve, reject) => {
            for (let indexEmployees = 0; indexEmployees < this.reportEmployee[selectedBranch][0].data.employees.length; indexEmployees++) {
              this.allEmployees.forEach(o => {
                //Wanneer de naam overeenkomt met ID.
                if(this.reportEmployee[selectedBranch][0].data.employees[indexEmployees].id == o.id) {
                  axios
                    .get(
                      "https://public.salonhub.nl/current/" +
                        this.activeCompData.salonhubApiSettings.customer +
                        "/" +
                        this.activeCompData.salonhubApiSettings.username +
                        "/" +
                        this.activeCompData.salonhubApiSettings.md5 +
                        "/salon/" +
                        [selectedBranch] +
                        `/getReport?name=Reports.Financial.Overview&parameters={"period":"year","year":${moment(
                          this.momentCurrentYearDate
                        ).year()},"from":"${moment(this.momentCurrentYearDate)
                          .startOf("year")
                          .format("YYYY-MM-DD")}","to":"${moment(
                          this.momentCurrentYearDate
                        )
                          .endOf("year")
                          .format("YYYY-MM-DD")}","previous":{"year":${moment(
                          this.momentCurrentYearDate
                        )
                          .subtract(1, "years")
                          .format("YYYY")},"from":"${moment(
                          this.momentCurrentYearDate
                        )
                          .startOf("year")
                          .subtract(1, "years")
                          .format("YYYY-MM-DD")}","to":"${moment(
                          this.momentCurrentYearDate
                        )
                          .endOf("year")
                          .subtract(1, "years")
                          .format("YYYY-MM-DD")}"},"employee":"${
                          this.reportEmployee[selectedBranch][0].data.employees[indexEmployees].id
                        }","group":"","unit":""}`
                    )
                    .then(response => {
                      //Opsplitsen van persoonlijke productdata

                      let newData = { id: this.reportEmployee[selectedBranch][0].data.employees[indexEmployees].id,
                        name: this.reportEmployee[selectedBranch][0].data.employees[indexEmployees].name,
                        branch: selectedBranch,
                        fourweeksTotalRevenue: 0,
                        week: null,
                        products: null
                      };

                      //Gaat door de binnenkomende data en pakt de week als key los op.

                      let companyDataView = this.activeCompData
                        .barometersSettings.dataView;
                      let dataView = this.dataFilterSaved.selectedDataView;
                      let dataNumber = null;

                      //Omzet per persoon per 4 weken
                      _.forEach(response.data.data.fourweeks, key => {
                        if (dataView == "weeks") {
                          if (
                            key.fourweek ==
                            Math.ceil(this.dataFilter.selectedDataWeek / 4)
                          ) {
                            newData.fourweeksTotalRevenue = key.total;
                          }
                        }

                        if (dataView == "fourweeks") {
                          if (
                            key.fourweek ==
                            this.dataFilter.selectedDataFourWeeks
                          ) {
                            newData.fourweeksTotalRevenue = key.total;
                          }
                        }
                       
                      });

                      if (dataView == "months") {
                        dataNumber = this.dataFilterSaved.selectedDataMonths;
                        _.forEach(response.data.data.months, key => {
                          if (Number(key.month) == dataNumber) {
                            newData.month = Number(key.month);
                            newData.fourweeks = null;
                            newData.week = null;
                            newData.fourweeksTotalRevenue = key.total;
                            newData.products = key.products;
                          }
                        });
                      } else if (dataView == "fourweeks") {
                        dataNumber = this.dataFilterSaved.selectedDataFourWeeks;
                        _.forEach(response.data.data.fourweeks, key => {
                          // console.log(key);
                          if (Number(key.month) == dataNumber) {
                            newData.month = null;
                            newData.fourweeks = Number(key.fourweek);
                            newData.week = null;
                            newData.products = key.products;
                          }
                        });
                      } else {
                        dataNumber = this.dataFilterSaved.selectedDataWeek;
                        _.forEach(response.data.data.weeks, key => {
                          if (Number(key.week) == dataNumber) {
                            newData.month = null;
                            newData.fourweeks = null;
                            newData.week = Number(key.week);
                            newData.products = key.products;
                          }
                        });
                      }

                      // SVEN

                      this.financeEmployee.push(newData);
                    })
                    .then(() => {
                      financeCounterTwo++;
                      if(financeCounterTwo ==this.reportEmployee[selectedBranch][0].data.employees.length) {
                        resolve();
                      }
                    })
                    .catch(error => {
                      console.error("Employee FinanceCounterTwo Error", error);
                      financeCounterTwo++;
                      if(financeCounterTwo ==this.reportEmployee[bselectedBranch][0].data.employees.length) {
                        resolve();
                      }
                    });
                } else {
                  financeCounterTwo++;
                  if(financeCounterTwo ==this.reportEmployee[selectedBranch][0].data.employees.length) {
                    resolve();
                  }
                }
              });
            }
          })
          .then(() => {
            financeCounter++;
            if (financeCounter == this.selectedBranchesSalonhub.length) {
              resolve();
            }
          });
        })
      })
      .then(() => {
        //console.log("Klaar met laden Employee Finance");

        //console.log("Echt klaar met laden");
        this.employeeloaded = true;
        if(this.activeCompDataOriginal.barometersSettings.showAllround){
          this.loadAllround(); //Alle data is binnen we rekenen 1 malig alles uit.
        }

        this.dataloaded = true;
        this.loadingError = null;

      })
      .catch(error => {
        this.dataloaded = true;
        this.loadingError = "Er is iets fout gegaan bij het binnenhalen van Salonhub. Probeer het opnieuw.";
        console.error("Error met laden deel 2");
      });
    },

    async loadProductData(salon) {
      /*
      1. Omrekenen vorig naar nieuw doel gewenste x %  -> newTarget
      2. Huidige status berekenen in percentage tov newTarget
      Optioneel, weken zijn te vergelijken.
      */
      let productCounter = 0
      // console.log("Product data laden: " , salon);
      let dataView = this.dataFilterSaved.selectedDataView;
      let dataNumber = null;
      let dataViewSalonhub = null;

      if (dataView == "months") {
        dataNumber = String(this.dataFilterSaved.selectedDataMonths);
        dataViewSalonhub = 'month';
      } else if (dataView == "fourweeks") {
        dataNumber = String(this.dataFilterSaved.selectedDataFourWeeks);
        dataViewSalonhub = 'fourweek';
      } else if (dataView == "weeks") {
        dataNumber = String(this.dataFilterSaved.selectedDataWeek);
        dataViewSalonhub = 'week';
      }

      let productTarget = null;
      let productManipulate = null;
    
      await new Promise((resolve)=>{
        this.selectedBranchesData.forEach(branch=>{
          if (branch.branchNameSalonhub == salon) {
            if (branch.barometersSettings) {
              if(branch.barometersSettings.useManualGoals){
                productManipulate = 0;
                productTarget = 0;
              }
              else{
                if (branch.barometersSettings.ProductSaleTarget) {
                  productTarget = branch.barometersSettings.ProductSaleTarget;

                  if (branch.barometersSettings.ProductManipulateActive && branch.barometersSettings.ProductManipulate) {
                    productManipulate = branch.barometersSettings.ProductManipulate;
                  }
                  else {
                    productManipulate = branch.barometersSettings.ProductSaleTarget;
                  }
                }
                else {
                  productTarget = null;
                  productManipulate = null;
                }
              }            
            }
            else {
              productTarget = null;
              productManipulate = null;
            }
            let newTarget = null;
            let actualStatus = 0;

            // let salonhubData = _.find(this.ThisYearData[salon][0].data[dataView],[dataViewSalonhub,Number(dataNumber)]);
            // let salonhubDataLastYear = _.find(this.SettingYearData[salon][0].data[dataView], [dataViewSalonhub,dataNumber]);
            let salonhubData = _.find(this.ThisYearData[salon][0].data[dataView], function(o) { return o[dataViewSalonhub] == dataNumber; });
            let salonhubDataLastYear = _.find(this.SettingYearData[salon][0].data[dataView], function(o) { return o[dataViewSalonhub] == dataNumber; });

            if (salonhubData && salonhubDataLastYear && productTarget != null) {
              newTarget = (salonhubDataLastYear.products * (productTarget + 100)) / 100;
              this.productData.actual[salon] = salonhubData.products; //Jaar terug
              actualStatus = (salonhubData.products / newTarget) *100;
            } 
            else {
              this.productData.actual[salon] = 0;
            }

            this.productData.target[salon] = newTarget;
            this.productData.percentageActual[salon] = actualStatus;
            this.productData.percentageSaleTarget[salon] = branch.barometersSettings.useManualGoals ? salonhubDataLastYear.products : productTarget;
            this.productData.percentageManipulate[salon] = branch.barometersSettings.useManualGoals ? salonhubDataLastYear.products : productManipulate;
          }

          productCounter++
          if(productCounter == this.selectedBranchesData.length){
            resolve()
          }
        })
      })
      .then(()=>{
        return  
      })
    },

    async loadTreatmentData(salon) {

      //console.log("Treatment data laden");
      let dataView = this.dataFilterSaved.selectedDataView;
      let dataNumber = null;
      let dataViewSalonhub = null;

      if (dataView == "months") {
        dataNumber = String(this.dataFilterSaved.selectedDataMonths);
        dataViewSalonhub = 'month';
      } else if (dataView == "fourweeks") {
        dataNumber = String(this.dataFilterSaved.selectedDataFourWeeks);
        dataViewSalonhub = 'fourweek';
      } else if (dataView == "weeks") {
        dataNumber = String(this.dataFilterSaved.selectedDataWeek);
        dataViewSalonhub = 'week';
      }

      let treatmentTarget = null;
      let treatmentManipulate = null;
      let branchCounter = 0

      new Promise((resolve,reject)=>{
        this.selectedBranchesData.forEach(branch =>{
          if (branch.branchNameSalonhub == salon) {
            if (branch.barometersSettings) {
              if(branch.barometersSettings.useManualGoals){
                treatmentManipulate = 0;
                treatmentTarget = 0;
              }
              else{
                if (branch.barometersSettings.TreatmentSaleTarget) {

                  treatmentManipulate = branch.barometersSettings.TreatmentSaleTarget;
                  if (branch.barometersSettings.TreatmentManipulateActive && branch.barometersSettings.TreatmentManipulate) {
                    treatmentTarget = branch.barometersSettings.TreatmentManipulate;
                  } 
                  else {
                    treatmentTarget = branch.barometersSettings.TreatmentSaleTarget;
                  }
                } else {
                  treatmentTarget = null;
                  treatmentManipulate = null;
                }
              }
            } 
            else {
              treatmentTarget = null;
              treatmentManipulate = null;
            }      

            let newTarget = null;
            let actualStatus = 0;
      
            // let salonhubData = _.find(this.ThisYearData[salon][0].data[dataView],[dataViewSalonhub,Number(dataNumber)]);
            // let salonhubDataLastYear = _.find(this.SettingYearData[salon][0].data[dataView], [dataViewSalonhub, Number(dataNumber)]);

            let salonhubData = _.find(this.ThisYearData[salon][0].data[dataView], function(o) { return o[dataViewSalonhub] == dataNumber; });
            let salonhubDataLastYear = _.find(this.SettingYearData[salon][0].data[dataView], function(o) { return o[dataViewSalonhub] == dataNumber; });
     
            if(salonhubData && salonhubDataLastYear && treatmentTarget != null) {
              newTarget = (salonhubDataLastYear.treatments * (treatmentTarget + 100)) / 100;
              this.treatmentData.actual[salon] = salonhubData.treatments; //Jaar terug
              actualStatus = (salonhubData.treatments / newTarget) * 100;
            }
            else {
              this.treatmentData.actual[salon] = 0;
            }

            this.treatmentData.target[salon] = newTarget;
            this.treatmentData.percentageActual[salon] = actualStatus;

            this.treatmentData.percentageSaleTarget[salon] = branch.barometersSettings.useManualGoals ? salonhubDataLastYear.treatments : treatmentTarget;
            this.treatmentData.percentageManipulate[salon] = branch.barometersSettings.useManualGoals ? salonhubDataLastYear.treatments : treatmentManipulate;
          } 
          branchCounter++
          if(branchCounter == this.selectedBranchesData.length){
            resolve();
          }
        })

      })
      .then(()=>{
        this.loadTotal(salon)
      })
      .then(()=>{
        // console.log("loadTreatmentData Salon:", salon, "returned")
        return        
      })
    },

    async loadTotal(salon) {
      // console.log("Week data laden");
      this.totalData.percentageActual[salon] = 0;
      this.totalData.target[salon] = null;
      this.totalData.actual[salon] = null;

      let target = 0;
      let actual = 0;

  
      if ((this.productData.target && this.productData.target[salon]) && (this.treatmentData.target && this.treatmentData.target[salon])) {
        target = this.productData.target[salon] + this.treatmentData.target[salon];
      } 
      else if ((!this.productData.target || !this.productData.target[salon]) && (this.treatmentData.target && this.treatmentData.target[salon])) {
        target = this.treatmentData.target[salon];
      } 
      else if ((this.productData.target && this.productData.target[salon]) && (!this.treatmentData.target || !this.treatmentData.target[salon])) {
        target = this.productData.target[salon];
      }


      if ((this.productData.actual && this.productData.actual[salon]) && (this.treatmentData.actual && this.treatmentData.actual[salon])) {
        actual = this.productData.actual[salon] + this.treatmentData.actual[salon];
      } 
      else if ((!this.productData.actual || !this.productData.actual[salon]) && (this.treatmentData.actual && this.treatmentData.actual[salon])) {
        actual = this.treatmentData.actual[salon];
      } 
      else if ((this.productData.actual && this.productData.actual[salon]) && (!this.treatmentData.actual || !this.treatmentData.actual[salon])) {
        actual = this.productData.actual[salon];
      }

      // console.log("TARGET DATA: ", target)
      // console.log("ACTUAL DATA: ", actual)

      if (target || actual) {
        this.totalData.percentageActual[salon] = (actual / target) * 100;
        this.totalData.target[salon] = target;
        this.totalData.actual[salon] = actual;
      }
      return
    },

    async load4weeksTotal(salon) {
      // console.log("4 weeks data laden");

      let companyDataView = this.activeCompData.barometersSettings.dataView;
      let dataView = this.dataFilterSaved.selectedDataView;
      let dataNumber = null;
      let dataViewSalonhub = null;

      if (dataView == "months") {
        dataNumber = this.dataFilterSaved.selectedDataMonths;
        dataViewSalonhub = 'month';
      }
      else if (dataView == "fourweeks") {
        dataNumber = this.dataFilterSaved.selectedDataFourWeeks;
        dataViewSalonhub = 'fourweek';
        
      } else if (dataView == "weeks") {
        if (companyDataView == "fourweeks") {
          dataView = "fourweeks";
          dataViewSalonhub = 'fourweek';
          dataNumber = Math.ceil(this.dataFilterSaved.selectedDataWeek / 4);
        } else {
          dataView = "months";
          dataViewSalonhub = 'month';
          dataNumber = String(
            moment()
              .week(this.dataFilterSaved.selectedDataWeek)
              .format("M")
          );
        }
      }

      let totalPeriodViewTarget = null;
      let totalPeriodManipulateTarget = null;
      let totalPeriodTarget = null;

      let branchCounter = 0

      new Promise((resolve,reject)=>{
        this.selectedBranchesData.forEach(branch =>{
          if (branch.branchNameSalonhub == salon) {
            if (branch.barometersSettings) {
              if(branch.barometersSettings.useManualGoals){
                totalPeriodManipulateTarget = 0;
                totalPeriodTarget = 0;
                totalPeriodViewTarget = branch.barometersSettings.Total4WeeksSaleTarget ? branch.barometersSettings.Total4WeeksSaleTarget : null;
              }
              else{
                if (branch.barometersSettings.Total4WeeksSaleTarget) {
                  totalPeriodViewTarget = branch.barometersSettings.Total4WeeksSaleTarget;
                  if (branch.barometersSettings.Total4WeeksSaleManipulateActive && branch.barometersSettings.Total4WeeksSaleManipulate){
                    totalPeriodManipulateTarget = branch.barometersSettings.Total4WeeksSaleManipulate;
                    totalPeriodTarget = branch.barometersSettings.Total4WeeksSaleManipulate;
                  }
                  else if (branch.barometersSettings.Total4WeeksSaleTarget) {
                    totalPeriodManipulateTarget = 0;
                    totalPeriodTarget = branch.barometersSettings.Total4WeeksSaleTarget;
                  }
                  else {
                    totalPeriodManipulateTarget = 0;
                    totalPeriodTarget = 0;
                  }
                }
                else {
                  totalPeriodViewTarget = null;
                  totalPeriodManipulateTarget = null;
                  totalPeriodTarget = null;
                }
              }
            }
            else {
              totalPeriodViewTarget = null;
              totalPeriodManipulateTarget = null;
              totalPeriodTarget = null;
            }
          
            let newTarget = null;

            let salonhubData = _.find(this.ThisYearData[salon][0].data[dataView],[dataViewSalonhub,dataNumber]);
            let salonhubDataLastYear = _.find(this.SettingYearData[salon][0].data[dataView], [dataViewSalonhub,dataNumber]);

            if (totalPeriodTarget !== null) {
              newTarget = (salonhubDataLastYear.total * (totalPeriodTarget + 100)) / 100;
            }
            else{
              newTarget = 0;
            }

            // let actualStatus = (this.ThisYearData[salon][0].data.fourweeks[dataNumber].total * (total4weeksTarget + 100)) / newTarget; FOUTIEF!!

            let actualStatus = null;

            if (salonhubDataLastYear && newTarget) {
              actualStatus = (salonhubData.total / newTarget) * 100;
            }

            this.totalPeriodData.target[salon] = newTarget;
            this.totalPeriodData.actual[salon] = 0;
            if (salonhubData) {
              this.totalPeriodData.actual[salon] = salonhubData.treatments; //Jaar terug
            }

            this.totalPeriodData.percentageActual[salon] = actualStatus;
            this.totalPeriodData.percentageSaleTarget[salon] = branch.barometersSettings.useManualGoals ? salonhubDataLastYear.total : totalPeriodViewTarget;
            this.totalPeriodData.percentageManipulate[salon] = branch.barometersSettings.useManualGoals ? salonhubDataLastYear.total : totalPeriodManipulateTarget;




          }

          branchCounter++
          if(branchCounter == this.selectedBranchesData.length){
            resolve()
          }
        })
      })
      .then(()=>{
        return
      })
      

   
      
    },

    async loadColours(salon) {
      let colourTarget = null;
      this.selectedBranchesData.forEach(o => {
        if (o.branchNameSalonhub == salon) {
          // Kijken of er een target is ingesteld
          if (o.barometersSettings && o.barometersSettings.ColourSaleTarget) {
            // Kijken welke view is gekozen maand / 4 weken / week
            if (this.dataFilterSaved.selectedDataView == "months") {
              // Aantal dagen in de gekozen maand berekenen om zo het week doel om te zetten naar maanddoel
              let currentMonth = moment(
                "01-" +
                  this.dataFilterSaved.selectedDataMonths +
                  "-" +
                  this.dataFilterSaved.selectedDataYear
              );
              let daysInMonth = moment(currentMonth).daysInMonth();
              colourTarget =
                (o.barometersSettings.ColourSaleTarget / 7) * daysInMonth;
            } else if (this.dataFilterSaved.selectedDataView == "fourweeks") {
              // Weekdoel omzetten naar 4 weken doel
              colourTarget = o.barometersSettings.ColourSaleTarget * 4;
            } else {
              colourTarget = o.barometersSettings.ColourSaleTarget;
            }
          }
        }
      });

      let actualColours = 0;
      _.forEach(this.Revenue[salon][0].data.categories, function(o) {
        if (o.name == "Kleuringen") {
          actualColours = o.count;
        }
      });

      this.colourData.actual[salon] = actualColours;
      this.colourData.colourTarget[salon] = colourTarget;
    },

    async loadCreative(salon) {
      let colourTarget = 0;
      let creativeShow = false;

      this.selectedBranchesData.forEach(o => {
        if (o.branchNameSalonhub == salon) {
          // Kijken of er een target is ingesteld
          if (o.barometersSettings && o.barometersSettings.ColourSaleTarget) {
            // Kijken welke view is gekozen maand / 4 weken / week
            if (this.dataFilterSaved.selectedDataView == "months") {
              // Aantal dagen in de gekozen maand berekenen om zo het week doel om te zetten naar maanddoel
              let currentMonth = moment(
                "01-" +
                  this.dataFilterSaved.selectedDataMonths +
                  "-" +
                  this.dataFilterSaved.selectedDataYear
              );
              let daysInMonth = moment(currentMonth).daysInMonth();
              colourTarget =
                (o.barometersSettings.ColourSaleTarget / 7) * daysInMonth;
            } else if (this.dataFilterSaved.selectedDataView == "fourweeks") {
              // Weekdoel omzetten naar 4 weken doel
              colourTarget = o.barometersSettings.ColourSaleTarget * 4;
            } else {
              colourTarget = o.barometersSettings.ColourSaleTarget;
              if (this.dataFilterSaved.selectedDataWeek == moment().week()) {
                creativeShow = true;
              }
            }
          }
        }
      });

      var actualperperiod = null;
      _.forEach(this.Revenue[salon][0].data.categories, function(o) {
        if (o.name == "Kleuringen") {
          actualperperiod = o.count;
        }
      });

      let target = colourTarget / 5;
      this.creativeData.percentageActual[salon] = (
        (100 * actualperperiod) /
        target
      ).toFixed(1);
      this.creativeData.target[salon] = target;
      this.creativeData.show[salon] = creativeShow;
    },

    async loadAppointmentData(salon){
      await axios
        .get(
          "https://public.salonhub.nl/current/" +
            this.activeCompData.salonhubApiSettings
              .customer +
            "/" +
            this.activeCompData.salonhubApiSettings
              .username +
            "/" +
            this.activeCompData.salonhubApiSettings.md5 +
            "/salon/" +
            salon +
            `/getReport?name=Reports.Appointments.Overview&parameters={"period":"year","year":${
              this.currentYear
            },"from":"${this.currentYear}-01-01","to":"${
              this.currentYear
            }-12-31","previous":{"year":${
              this.yearTwoYearsAgo
            },"from":"${
              this.yearTwoYearsAgo
            }-01-01","to":"${
              this.yearTwoYearsAgo
            }-12-31"},"next":{"year":${
              this.yearOneYearsAgo
            },"from":"${
              this.yearOneYearsAgo
            }-01-01","to":"${
              this.yearOneYearsAgo
            }-12-31"},"employee":"","state":0}`
        )
        .then(response => {
          // console.log("Afspraken dit jaar zijn binnen: ", salon)
          this.AppointmentsThisYear[salon] = [];
          this.AppointmentsThisYear[salon].push(response.data);
          
        });

      //Afspraken vorig jaar
      // console.log("Afspraken vorig jaar binnenladen: ", salon)
      await axios
      .get(
        "https://public.salonhub.nl/current/" +
          this.activeCompData.salonhubApiSettings
            .customer +
          "/" +
          this.activeCompData.salonhubApiSettings
            .username +
          "/" +
          this.activeCompData.salonhubApiSettings.md5 +
          "/salon/" +
          salon +
          `/getReport?name=Reports.Appointments.Overview&parameters={"period":"year","year":${
            this.yearOneYearsAgo
          },"from":"${
            this.yearOneYearsAgo
          }-01-01","to":"${
            this.yearOneYearsAgo
          }-12-31","previous":{"year":${
            this.yearTwoYearsAgo
          },"from":"${
            this.yearTwoYearsAgo
          }-01-01","to":"${
            this.yearTwoYearsAgo
          }-12-31"},"next":{"year":${
            this.yearOneYearsAgo
          },"from":"${
            this.yearOneYearsAgo
          }-01-01","to":"${
            this.yearOneYearsAgo
          }-12-31"},"employee":"","state":0}`
      )

      .then(response => {
        //console.log("Afspraken vorig jaar zijn binnen: ", salon)
        // console.log(response.data);
        this.AppointmentsYearAgo[salon] = [];
        this.AppointmentsYearAgo[salon].push(response.data);
      });
      // console.log("loadColor Salon:", salon, "returned") 
      return
          

          
    },

    async loadAllround() {
     //console.log("Allround data laden");

      //Loop 1 zoek naar Allround Employees
      for (let [key, value] of Object.entries(this.activeCompData.benchmarkEmployees)) {
        if (typeof this.activeCompData.benchmarkEmployees[key].allround !== "undefined" && this.activeCompData.benchmarkEmployees[key].allround == true) {
          // console.log(key);
          //Loop 2 welke branches uitrekenen?
          let counterPass = 0; //voor Gemiddelde
          let sumAllround = 0;
          let summAllroundRevenueHour = 0;
          let dyflexisHours = 0;
          let dyflexisMinutes = null




          for (
            let index = 0;
            index < this.selectedBranchesSalonhub.length;
            index++
          ) {
            // console.log([branchData.branchNameSalonhub]);
            //Loop 3 overeenkomst indentificeren en optellen

            this.reportEmployee[this.selectedBranchesSalonhub[index]][0].data.employees.forEach(o => {
              if (o.id == key) {
                counterPass++;
                //Match en optellen.
                sumAllround += o.revenue;
                summAllroundRevenueHour += o.revenuePerHour;
                dyflexisHours += o.dyflexisHours ? o.dyflexisHours :0;
                dyflexisMinutes += o.dyflexisMinutes ? o.dyflexisMinutes :0;
              }
            });
          }

          this.allRoundEmployees.push({
            id: key,
            allroundsum: sumAllround,
            revenuePerHour: Number((summAllroundRevenueHour / counterPass).toFixed(1)),
            dyflexisHours: dyflexisHours,
            dyflexisMinutes: dyflexisMinutes
          });
        }
      }
    },
    
    async loadCustomProductData(salon){
      // console.log("Revenue per Productgroep data laden");
      let startOfMonth = String(this.dataFilterSaved.selectedDataYear)+"-"+String(this.dataFilterSaved.selectedDataMonths)+"-01"
      let momentTime = moment().month(this.dataFilterSaved.selectedDataMonths - 1).format("YYYY-MM-DD");

      let selectedMonth = moment().month(this.dataFilterSaved.selectedDataMonths - 1).format("M");
      let selectedYear = this.dataFilterSaved.selectedDataYear;
      let dataFilterStartDate = moment(startOfMonth).startOf("month").format("YYYY-MM-DD");
      let dataFilterEndDate = moment(startOfMonth).endOf("month").format("YYYY-MM-DD");
      let branchesCounter = 0

      // console.log("startOfMonth: ", startOfMonth);

      new Promise((resolve,reject)=>{
        this.selectedBranchesData.forEach(branch => {

          if (branch.branchNameSalonhub == salon) {
            this.revenuePerTicket[branch.branchNameSalonhub] = {
              current: 0,
              target: 0
            }
            
            // https://public.salonhub.nl/current/hairbeautycomp/hoganstest/1335ca1902c96119513f26c92fbff112/salon/demeern/getReport?name=Reports.Sales.Products&parameters={"period":"month","year":2020,"month:"1,"from":"2020-01-01","to":"2020-01-31","employee":""}
            
            let salonhubURL = "https://public.salonhub.nl/current/" +
              this.activeCompData.salonhubApiSettings.customer +
              "/" +
              this.activeCompData.salonhubApiSettings.username +
              "/" +
              this.activeCompData.salonhubApiSettings.md5 +
              "/salon/"+ branch.branchNameSalonhub + `/getReport?name=Reports.Sales.Products&parameters={"period":"month","year":${selectedYear},"month":${selectedMonth},"from":"${dataFilterStartDate}","to":"${
                dataFilterEndDate
              }","employee":""}`

            axios
              .get(salonhubURL).then(response => {

                let productTypeData = response.data.data.category
                let styling = 0 
                let techniart = 0
                
                if(_.find(productTypeData, { 'name': "Styling", })){
                  styling = _.find(productTypeData, { 'name': "Styling", })
                }

                if(_.find(productTypeData, { 'name': "Techni. Art"})){
                  techniart = _.find(productTypeData, { 'name': "Techni. Art"});
                }

                this.customProductData[branch.branchNameSalonhub] = {}
                this.customProductData[branch.branchNameSalonhub].count = (styling.count + techniart.count)

                branchesCounter++
                

                if(branchesCounter == this.selectedBranchesData.length){
                  resolve()
                }
              })
              .catch(error=>{
                console.error("Error binnenhalen ProductGroupData: ", error)
                branchesCounter++
                if(branchesCounter == this.selectedBranchesData.length){
                  resolve()
                }
              })
          }
          else{
            branchesCounter++
            if(branchesCounter == this.selectedBranchesData.length){
              resolve()
            }
          }
        })

      })
      .then(()=>{
        // console.log("loadCustomProductData Salon:", salon, "returned") 
        return
      })
      
    },

    async loadRevenuePerTicket(salon){
      // console.log("Revenue per Ticket data laden");
      let momentTime = moment().month(this.dataFilterSaved.selectedDataMonths - 1).format("YYYY-MM-DD");
      let dataFilterStartDate = moment(momentTime).startOf("month").format("YYYY-MM-DD");
      let dataFilterEndDate = moment(momentTime).endOf("month").format("YYYY-MM-DD");
      let branchesCounterTicket = 0
      
      new Promise((resolve)=>{
        
        this.selectedBranchesData.forEach(branch => {
          if (branch.branchNameSalonhub == salon) {
            this.revenuePerTicket[branch.branchNameSalonhub] = {
              current: 0,
              target: 0
            };

            let apiUrlRevenueTicket = `https://public.salonhub.nl/current/${this.activeCompData.salonhubApiSettings.customer}/${this.activeCompData.salonhubApiSettings.username}/${this.activeCompData.salonhubApiSettings.md5}/salon/${branch.branchNameSalonhub}/getReport?name=Reports.Salon.Benchmark&parameters={"period":"month","from":"${dataFilterStartDate}","to":"${dataFilterEndDate}"}`;

            axios.get(apiUrlRevenueTicket)
              .then(response => {
                if(response.data.data.servicePerServiceTicket.current){
                  this.revenuePerTicket[branch.branchNameSalonhub].current = response.data.data.servicePerServiceTicket.current
                }
                if(branch.barometersSettings.revenuePerTicket){
                  this.revenuePerTicket[branch.branchNameSalonhub].target = branch.barometersSettings.revenuePerTicket
                  // console.log("TARGET REV / Ticket : ", branch.barometersSettings.revenuePerTicket)
                }

                branchesCounterTicket++
                if(branchesCounterTicket == this.selectedBranchesData.length){
                  resolve()
                }
              })
              .catch(error=>{
                console.error("Error binnenhalen RevenuePerTicket: ", error)
                branchesCounterTicket++
                if(branchesCounterTicket == this.selectedBranchesData.length){
                  resolve()
                }
              })
          } 
          else{
            branchesCounterTicket++
            if(branchesCounterTicket == this.selectedBranchesData.length){
              resolve()
            }
          }
        })

      })
      .then(()=>{
        // console.log("loadRevenuePerTicket Salon:", salon, "returned") 
        return
      })
      
    }
  },

  computed: {
    demoMode(){
      return this.$store.state.demoMode;
    },
    
    filterGridClass(){
      if(this.userCompanies.length > 1 && !this.demoMode){
        return "md6"
      } else {
        return "md9"
      }
    },
    
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    userBranches() {
      return this.$store.state.userBranches;
    },
    userId() {
      return this.$store.state.userId;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    companyPrimaryColorRGBA() {
      return this.$store.state.companyPrimaryColorRGBA;
    },
    companySecondaryColorRGBA() {
      return this.$store.state.companySecondaryColorRGBA;
    },
    filterChanged() {
      if (_.isEqual(this.dataFilter, this.dataFilterSaved) == false) {
        return false;
      } else {
        return true;
      }
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    filteredCompanies(){
      return this.companies.filter(company => {
        return company.name.toLowerCase().includes(this.searchCompanies.toLowerCase());
      });
    },
    branchesChanged() {
      if ( _.isEqual(this.selectedBranches, this.selectedBranchesOriginal)) {
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>
